import { TOggettoModalCaricamentoDati } from '@/utils/VUEModalCaricamentoDati.vue'
import { TZMathFunct } from '@/utils/ZMathFunct'
import { TZDateFunct } from '@/utils/ZDateFunct'
import { TInfoGraphic } from '../../InfoGraphic.js'
import { saveAs } from 'file-saver'
import { TZGenericFunct } from '@/utils/ZGenericFunct'
import { TIPOLOGIA_GRAFICI_STORICI, NR_OGGETTI_BOTTONI, SystemInformation, TIPI_UDM_X, COLORI_ALLARME_CRONOLOGIA_ACC, TIPO_ELEMENTO_PDF } from '@/SystemInformation'
import { TZStringConvFunct } from '@/utils/ZStringConvFunct'
import { TZDataTable, TZDTableColumnType, TZDTableRow, TZDataSingleField } from '@/utils/ZDataTable'

const COLOR_DEFAULT = 'rgb(0 0 0 /1)'
class TDataTableSegmenti
{
  constructor(GetTraduzioneLabel, LinguaUtente)
  {
    this.GetTraduzioneLabel = GetTraduzioneLabel
    this.LinguaUtente       = LinguaUtente
    this.DataTableSegmenti  = new TZDataTable('CHIAVE');
    this.DataTableSegmenti.ClearColumns();
    this.DataTableSegmenti.TastoAggiungiVisibile = false;
    this.DataTableSegmenti.EditRicercaVisibile = false;
    // this.DataTableSegmenti.Configurazione.Larghezza = '10%';


    var Colonna = this.DataTableSegmenti.AddColumn(GetTraduzioneLabel('Generic','TKN_SEGMENTO',LinguaUtente), TZDTableColumnType.typString, 'SEGMENTO', "2%");
    Colonna.Necessario = true

    this.DataTableSegmenti.AddColumn(GetTraduzioneLabel('Generic','TKN_DAL',LinguaUtente), TZDTableColumnType.typDateTime, 'DAL', "10%");
    // var DataDal = this.DataTableSegmenti.AddColumn(GetTraduzioneLabel('Generic','TKN_DAL',LinguaUtente), TZDTableColumnType.typDateTime, 'DAL', "10%");
    // DataDal.Necessario = true
    
    this.DataTableSegmenti.AddColumn(GetTraduzioneLabel('Generic','TKN_MAIUSC_AL',LinguaUtente), TZDTableColumnType.typDateTime, 'AL', "10%");
    // var DataAl = this.DataTableSegmenti.AddColumn(GetTraduzioneLabel('Generic','TKN_MAIUSC_AL',LinguaUtente), TZDTableColumnType.typDateTime, 'AL', "10%");
    // DataAl.Necessario = true

    Colonna = this.DataTableSegmenti.AddColumn(GetTraduzioneLabel('Generic','TKN_COEFFICENTE',LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_GIORNO',this.LinguaUtente) + ']', TZDTableColumnType.typString, 'VELOCITA', "57%");
    Colonna.ReadOnly = true
  }

  EliminaTuttiSegmenti()
  {
    this.DataTableSegmenti.DeleteAllRows()
  }

  AggiungiNuoviSegmenti(ListaSegmenti, ArrotondaOrario)
  {
    this.DataTableSegmenti.Righe = []
    if(ListaSegmenti.length > 0)
    {
      this.DataTableSegmenti.AddRowsOnTop(ListaSegmenti.length)
      
      for (let i = 0; i < ListaSegmenti.length; i++)
      {
        let SingolaRiga = this.DataTableSegmenti.Righe[i].Dati
        SingolaRiga.SEGMENTO.Valore = ListaSegmenti[i].Label

        SingolaRiga.DAL.Valore = ArrotondaOrario(ListaSegmenti[i].Dal)
        SingolaRiga.AL.Valore  = ArrotondaOrario(ListaSegmenti[i].Al)
      }
    }
  }

  CalcolaProgressivo()
  {
    let Self = this
    let Progressivo = 1

    if(Self.DataTableSegmenti.Righe && Self.DataTableSegmenti.Righe.length != 0)
    {
      let ListaNumeri = [];

      for(let i = 0; i < Self.DataTableSegmenti.Righe.length; i++)
      {
        let Valore = Self.DataTableSegmenti.Righe[i].Dati.SEGMENTO.Valore.substring(0,1)

        if (Valore === 'V' && !isNaN(Number(Self.DataTableSegmenti.Righe[i].Dati.SEGMENTO.Valore.substring(1,2))))
        {
          let Numero = Number(Self.DataTableSegmenti.Righe[i].Dati.SEGMENTO.Valore.substring(1));
          ListaNumeri.push(Numero);
        }

      }

      Progressivo = Math.max(...ListaNumeri) !== -Infinity ? Math.max(...ListaNumeri) + 1 : 1
    }

    return Progressivo
  }
  
  AggiungiSegmento()
  {
    let Self = this
    let Progressivo = Self.CalcolaProgressivo();

    var ANewRow = new TZDTableRow(true,Self.DataTableSegmenti.Configurazione,Self.DataTableSegmenti.OnRowChange);

    Self.DataTableSegmenti.Configurazione.Colonne.forEach(function(AColonna)
    {
        ANewRow.Dati[AColonna.Campo] = new TZDataSingleField(AColonna.Tipo);
        ANewRow.Graphics[AColonna.Campo] = {}
        
        if(AColonna.Tipo == TZDTableColumnType.typButton)
        {
          ANewRow.Graphics[AColonna.Campo].ButtonContent        = AColonna.ButtonContent;
          ANewRow.Graphics[AColonna.Campo].ButtonContentIsImage = AColonna.ButtonContentIsImage;
          ANewRow.Graphics[AColonna.Campo].ButtonContentDefault = AColonna.ButtonContentDefault;
          ANewRow.Graphics[AColonna.Campo].CampoDaPassareComeParametro = AColonna.CampoDaPassareComeParametro;
        }

        if(!AColonna.CampoCalcolato())
        {
            if(AColonna.DefaultValue != null)
            {
              switch(AColonna.Tipo)
              {
                    case TZDTableColumnType.typDate      : ANewRow.Dati[AColonna.Campo].Valore = TZDateFunct.DateInHTMLInputFormat(AColonna.DefaultValue);
                                                            break
                    case TZDTableColumnType.typTime      : ANewRow.Dati[AColonna.Campo].Valore = TZDateFunct.FormatDateTime('hh:nn',AColonna.DefaultValue);
                                                            break
                    case TZDTableColumnType.typDateTime  : ANewRow.Dati[AColonna.Campo].Valore = TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn',AColonna.DefaultValue);
                                                            break;
                    default                              : ANewRow.Dati[AColonna.Campo].Valore = AColonna.DefaultValue
                                                            break;
              }
            }
            else
            {
              switch(AColonna.Tipo)
              {
                  case TZDTableColumnType.typBoolean     : ANewRow.Dati[AColonna.Campo].Valore = false;
                                                          break;
                  case TZDTableColumnType.typString      :
                  case TZDTableColumnType.typMemo        : 
                  case TZDTableColumnType.typDate        :
                  case TZDTableColumnType.typTime        : 
                  case TZDTableColumnType.typMonth       :
                  case TZDTableColumnType.typDateTime    : ANewRow.Dati[AColonna.Campo].Valore = '';
                                                          break;
                  case TZDTableColumnType.typColor       : ANewRow.Dati[AColonna.Campo].Valore = COLOR_DEFAULT
                                                          break; 
                  case TZDTableColumnType.typSelect      : AColonna.Autocomplete? 
                                                          ANewRow.Dati[AColonna.Campo].Valore = -1 : 
                                                          ANewRow.Dati[AColonna.Campo].Valore = null;
                                                          break;
                  case TZDTableColumnType.typInteger     : if(AColonna.Progressivo) 
                                                          {  
                                                              ANewRow.Dati[AColonna.Campo].Valore = Self.GetMax(AColonna.Campo)
                                                              if(ANewRow.Dati[AColonna.Campo].Valore == null)
                                                                ANewRow.Dati[AColonna.Campo].Valore = 1
                                                              else ANewRow.Dati[AColonna.Campo].Valore += 1
                                                          }
                                                          else ANewRow.Dati[AColonna.Campo].Valore = 0;
                                                          break;
                  case TZDTableColumnType.typDecimi      :
                  case TZDTableColumnType.typCentesimi   : 
                  case TZDTableColumnType.typMilionesimi :
                  case TZDTableColumnType.typMillesimi   : ANewRow.Dati[AColonna.Campo].Valore = 0;
                                                          break;
                  case TZDTableColumnType.typAllegati    : break;
                                                          // ANewRow.Dati[AColonna.Campo].Valore = null;
              }
            }
        }
        else
        {
            if(AColonna.DefaultValue != null)
            {
              ANewRow.Dati[AColonna.Campo].Valore = AColonna.DefaultValue;
            }
        }
    });

    ANewRow.Dati.SEGMENTO.Valore = `V${Progressivo}` 
    ANewRow.OnChange('*');

    Self.DataTableSegmenti.Righe.push(ANewRow)
  }

  AggiungiNSegmenti(NumeroSegmenti, DatiSpostamento, ArrotondaOrario)
  {
    this.DataTableSegmenti.Righe = []
    this.DataTableSegmenti.AddRowsOnTop(NumeroSegmenti)

    let DataIniziale
    let VariazioneTemporale
    let DatiSpostamentoPuliti = []

    if(DatiSpostamento != undefined)
    {
      for(let i = 0; i < DatiSpostamento.length; i++)
      {
        if(DatiSpostamento[i].Data != '')
        {
          DatiSpostamentoPuliti.push(DatiSpostamento[i]);
        }
      }
      
      DataIniziale  = Date.parse(DatiSpostamentoPuliti[0].Data)
      let DataFinale    = Date.parse(DatiSpostamentoPuliti[DatiSpostamentoPuliti.length-1].Data)

      let DeltaTime = DataFinale - DataIniziale
      VariazioneTemporale = DeltaTime / NumeroSegmenti
    }

    if(DataIniziale != undefined && VariazioneTemporale != undefined)
      for (let i = 0; i < NumeroSegmenti; i++)
      {
        let SingolaRiga = this.DataTableSegmenti.Righe[i].Dati
        SingolaRiga.SEGMENTO.Valore = `V${i + 1}`

        let DataSegmentoIniziale = DataIniziale + VariazioneTemporale * (i)
        let DataSegmentoFinale   = DataIniziale + VariazioneTemporale * (i + 1)

        SingolaRiga.DAL.Valore = ArrotondaOrario(DataSegmentoIniziale)
        SingolaRiga.AL.Valore  = ArrotondaOrario(DataSegmentoFinale)
      }
  }

  RinumeraSegmenti()
  {
    for(let i = 0; i < this.DataTableSegmenti.Righe.length; i++)
      this.DataTableSegmenti.Righe[i].Dati['SEGMENTO'].Valore = 'V' + (i + 1)
  }
}

export default
{
  methods: 
  {   

    MixInsConfermaPopupRemoveRighelloEvAcc(ObjGrafico, IsGraficoVerticale = false)
    {
      this.PopupRemoveRighello = false
      let index = this.ObjGrafico.ListaRighelli.findIndex((element) => {return element.PrettyDateTime == this.RighelloToRemove})
      ObjGrafico.ListaRighelli.splice(index, 1)

      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
    },

    MixInsConfermaPopupAddRighelloEvAcc(ObjGrafico, IsGraficoVerticale = false)
    {
      this.PopupAddRighello = false
      this.ObjNewRighello.DateTime = this.ObjNewRighello.Data + ' ' + this.ObjNewRighello.Ora
      this.ObjNewRighello.PrettyDateTime = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.ObjNewRighello.DateTime))
      ObjGrafico.ListaRighelli.push(this.ObjNewRighello)
      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()

      this.MixInsResetNewRighelloEvAcc()
    },

    MixInsResetNewRighelloEvAcc()
    {
      let NewRighello            = {}
      NewRighello.Data           = ''
      NewRighello.Ora            = ''
      NewRighello.Colore         = 'black'
      NewRighello.DateTime       = ''
      NewRighello.PrettyDateTime = ''
      this.ObjNewRighello        = NewRighello
    },

    MixInsConfermaPopupImpostazioniYEvAcc(IsGraficoVerticale = false)
    {
      this.PopupImpostazioniAsseY = false

      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
    },

    MixInsConfermaPopupUdmXEvAcc(ObjGrafico, IsGraficoVerticale = false)
    {
      ObjGrafico.AxisX.Modificato = true
      this.PopupUdmX = false

      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
    },

    MixInsUpdateModificheGraficheEvAcc(ObjGrafico, Sensore)
    {
      if(Sensore.GlobalAdattaUdmX != undefined)
        ObjGrafico.AxisX.UdmX = Sensore.GlobalAdattaUdmX
      if(Sensore.GlobalAdattaTipoUdmX != undefined)
        ObjGrafico.AxisX.TipoUdmX = Sensore.GlobalAdattaTipoUdmX
      if(Sensore.GlobalModificatoAsseX != undefined)
        ObjGrafico.AxisX.Modificato = Sensore.GlobalModificatoAsseX
      
      if(Sensore.GlobalMaxAdattamentoAsseY != undefined)
        ObjGrafico.AxisY.Max = Sensore.GlobalMaxAdattamentoAsseY
      if(Sensore.GlobalMinAdattamentoAsseY != undefined)
        ObjGrafico.AxisY.Min = Sensore.GlobalMinAdattamentoAsseY
      if(Sensore.GlobalUdmY != undefined)
        ObjGrafico.AxisY.Udm = Sensore.GlobalUdmY

      

      if(Sensore.NewColorAmpiezzaX != undefined && Sensore.NewColorAmpiezzaX != '')
      {
        this.ColorLabelX = Sensore.NewColorAmpiezzaX
        ObjGrafico.NewColorAmpiezzaX = Sensore.NewColorAmpiezzaX
      }
      if(Sensore.NewColorAmpiezzaY != undefined && Sensore.NewColorAmpiezzaY != '')
      {
        this.ColorLabelY = Sensore.NewColorAmpiezzaY
        ObjGrafico.NewColorAmpiezzaY = Sensore.NewColorAmpiezzaY
      }
      if(Sensore.NewColorAmpiezzaZ != undefined && Sensore.NewColorAmpiezzaZ != '')
      {
        this.ColorLabelZ = Sensore.NewColorAmpiezzaZ
        ObjGrafico.NewColorAmpiezzaZ = Sensore.NewColorAmpiezzaZ
      }
      if(Sensore.NewColorFrequenza != undefined && Sensore.NewColorFrequenza != '')
      {
        this.ColorLabelZ = Sensore.NewColorFrequenza
        ObjGrafico.NewColorFrequenza = Sensore.NewColorFrequenza
      }

      if(Sensore.RighelloGlobale != undefined && Sensore.RighelloGlobale != '')
      {
        ObjGrafico.ListaRighelli.push(Sensore.RighelloGlobale)
        Sensore.RighelloGlobale = ''
      }
      
      if(Sensore.RighelloGlobaleDaRimuovere != undefined && Sensore.RighelloGlobaleDaRimuovere != '')
      {
        let index = ObjGrafico.ListaRighelli.findIndex((element) => {return element.PrettyDateTime == Sensore.RighelloGlobaleDaRimuovere || element.Millisecondi == Sensore.RighelloGlobaleDaRimuovere})
        ObjGrafico.ListaRighelli.splice(index, 1)
        Sensore.RighelloGlobaleDaRimuovere = ''
      }

      this.Repaint++
    },

    MixInsOnClickAdattaEvAcc(ObjGrafico, IsGraficoVerticale = false)
    {
      ObjGrafico.AxisX.Modificato = false

      if(!IsGraficoVerticale)
        this.RepaintDeep++
      else this.Disegna()
    },

    MixInsSetObjGraficoEvAcc(ObjGrafico)
    {
      ObjGrafico.X                 = true
      ObjGrafico.Y                 = true
      ObjGrafico.Z                 = true
      ObjGrafico.SogliaSMS1        = true
      ObjGrafico.SogliaSMS2        = true
      ObjGrafico.SogliaSMS3        = true
      ObjGrafico.SogliaSMS4        = true
      ObjGrafico.SoglieRilevamento = true
      ObjGrafico.SogliaAllarme     = true
      let AxisY        = {}
      AxisY.Max        = 0
      AxisY.Min        = 0
      AxisY.Udm        = 0
      ObjGrafico.AxisY         = AxisY
      ObjGrafico.ListaRighelli = []
      let AxisX        = {}
      AxisX.TipoUdmX   = TIPI_UDM_X.Giorni
      AxisX.UdmX       = 1
      AxisX.Modificato = false
      ObjGrafico.AxisX = AxisX
    },

    MixInsSetObjGraficoTensAss(OggettoGrafico, ListaModuli, TipoGrafico)
    {
      OggettoGrafico.AxisY.Min = 0
      OggettoGrafico.AxisY.Max = 15
      OggettoGrafico.AxisY.Udm = 1

      if(TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.TENSIONE_ALIMENTAZIONE)
        this.CalcoloListaModuliTensione(OggettoGrafico, ListaModuli)
      else this.CalcoloListaModuliAssorbimento(OggettoGrafico, ListaModuli)
    },

    CalcoloListaModuliTensione(OggettoGrafico, ListaModuli)
    {
      OggettoGrafico.ListaModuli = []

      for(let i = 0; i < ListaModuli.length; i++)
      {

        if(ListaModuli[i].MinAdattamentoAsseYTen < OggettoGrafico.AxisY.Min)
          OggettoGrafico.AxisY.Min = ListaModuli[i].MinAdattamentoAsseYTen
        if(ListaModuli[i].MaxAdattamentoAsseYTen > OggettoGrafico.AxisY.Max)
          OggettoGrafico.AxisY.Max = ListaModuli[i].MaxAdattamentoAsseYTen

        OggettoGrafico.AxisY.Udm = ListaModuli[i].UdmYTen

        OggettoGrafico.ListaModuli.push({
                                            NomeModulo : ListaModuli[i].Id,
                                            Colore     : ListaModuli[i].Colore
                                         }) 
      }
    },

    CalcoloListaModuliAssorbimento(OggettoGrafico, ListaModuli)
    {
      OggettoGrafico.ListaModuli = []

      for(let i = 0; i < ListaModuli.length; i++)
      {
        if(ListaModuli[i].MinAdattamentoAsseYAss < OggettoGrafico.AxisY.Min)
          OggettoGrafico.AxisY.Min = ListaModuli[i].MinAdattamentoAsseYAss
        if(ListaModuli[i].MaxAdattamentoAsseYAss > OggettoGrafico.AxisY.Max)
          OggettoGrafico.AxisY.Max = ListaModuli[i].MaxAdattamentoAsseYAss

        OggettoGrafico.AxisY.Udm = ListaModuli[i].UdmYAss

        OggettoGrafico.ListaModuli.push({
                                            NomeModulo : ListaModuli[i].Id,
                                            Colore     : ListaModuli[i].Colore
                                         })
      }
    },

    MixInsConfermaPopupRemoveRighelloSpostamenti(ObjGrafico, IsGraficoVerticale = false)
    {
      this.PopupRemoveRighello = false
      let index = ObjGrafico.ListaRighelli.findIndex((element) => {return element.PrettyDateTime == this.RighelloToRemove})
      ObjGrafico.ListaRighelli.splice(index, 1)
      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
    },

    MixInsResetNewRighelloSpostamenti()
    {
      let NewRighello            = {}
      NewRighello.Data           = ''
      NewRighello.Ora            = ''
      NewRighello.Colore         = 'black'
      NewRighello.DateTime       = ''
      NewRighello.PrettyDateTime = ''
      this.ObjNewRighello        = NewRighello
    },
    
    MixInsConfermaPopupAddRighelloSpostamenti(ObjGrafico, IsGraficoVerticale = false)
    {
      this.PopupAddRighello = false
      this.ObjNewRighello.DateTime = this.ObjNewRighello.Data + ' ' + this.ObjNewRighello.Ora
      this.ObjNewRighello.PrettyDateTime = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.ObjNewRighello.DateTime))
      ObjGrafico.ListaRighelli.push(this.ObjNewRighello)
      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
      this.MixInsResetNewRighelloSpostamenti()
    },

    MixInsGetUnitaDiMisuraAsseYSpostamenti()
    {
      if(this.IsVelocitaGiornaliera)
        return '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_GG',this.LinguaUtente) + ']'
      if(this.IsAccelerazioneGiornaliera)
        return '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_2GG',this.LinguaUtente) + ']'
      if(this.IsVelocita)
        return '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_H',this.LinguaUtente) + ']'
      if(this.IsAccelerazione)
        return '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MM_2H',this.LinguaUtente) + ']'
      return '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
    },

    MixInsConfermaPopupImpostazioniYSpostamenti(ObjGrafico, IsGraficoVerticale = false)
    {
      if(this.OggettoTotaleSpostamento != null)
      {
        this.CurrentOggettoTotaleSpostamento.MaxAdattamentoAsseYSpost = ObjGrafico.AxisY.Max
        this.CurrentOggettoTotaleSpostamento.MinAdattamentoAsseYSpost = ObjGrafico.AxisY.Min
        this.CurrentOggettoTotaleSpostamento.UdmYSpost                = ObjGrafico.AxisY.Udm
      }
      else
      {
        if(this.IsVelocita || this.IsVelocitaGiornaliera)
        {
          this.CurrentModulo.MaxAdattamentoAsseYVel = ObjGrafico.AxisY.Max
          this.CurrentModulo.MinAdattamentoAsseYVel = ObjGrafico.AxisY.Min
          this.CurrentModulo.UdmYVel                = ObjGrafico.AxisY.Udm
        }
        else if(this.IsAccelerazione || this.IsAccelerazioneGiornaliera)
        {
          this.CurrentModulo.MaxAdattamentoAsseYAccel = ObjGrafico.AxisY.Max
          this.CurrentModulo.MinAdattamentoAsseYAccel = ObjGrafico.AxisY.Min
          this.CurrentModulo.UdmYAccel                = ObjGrafico.AxisY.Udm
        }
        else
        {
          this.CurrentModulo.MaxAdattamentoAsseYSpost = ObjGrafico.AxisY.Max
          this.CurrentModulo.MinAdattamentoAsseYSpost = ObjGrafico.AxisY.Min
          this.CurrentModulo.UdmYSpost                = ObjGrafico.AxisY.Udm
        }
      }
      ObjGrafico.AxisY.Modificato       = true
      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
      this.PopupImpostazioniAsseY = false
    },

    MixInsAnnullaPopupImpostazioniYSpostamenti(ObjGrafico)
    {
      if(this.OggettoTotaleSpostamento != null)
      {
        ObjGrafico.AxisY.Max = this.OggettoTotaleSpostamento.MaxAdattamentoAsseYSpost
        ObjGrafico.AxisY.Min = this.OggettoTotaleSpostamento.MinAdattamentoAsseYSpost
        ObjGrafico.AxisY.Udm = this.OggettoTotaleSpostamento.UdmYSpost               
      }
      else
      {
        if(this.IsVelocita || this.IsVelocitaGiornaliera)
        {
          ObjGrafico.AxisY.Max = this.CurrentModulo.MaxAdattamentoAsseYVel
          ObjGrafico.AxisY.Min = this.CurrentModulo.MinAdattamentoAsseYVel
          ObjGrafico.AxisY.Udm = this.CurrentModulo.UdmYVel               
        }
        else if(this.IsAccelerazione || this.IsAccelerazioneGiornaliera)
        {
          ObjGrafico.AxisY.Max = this.CurrentModulo.MaxAdattamentoAsseYAccel
          ObjGrafico.AxisY.Min = this.CurrentModulo.MinAdattamentoAsseYAccel
          ObjGrafico.AxisY.Udm = this.CurrentModulo.UdmYAccel               
        }
        else
        {
          ObjGrafico.AxisY.Min = this.CurrentModulo.MinAdattamentoAsseYSpost
          ObjGrafico.AxisY.Max = this.CurrentModulo.MaxAdattamentoAsseYSpost
          ObjGrafico.AxisY.Udm = this.CurrentModulo.UdmYSpost
        }
      }
      this.PopupImpostazioniAsseY = false
    }, 

    MixInsOnClickAdattaSpostamenti(ObjGrafico, IsGraficoVerticale = false)
    {
      if(this.OggettoTotaleSpostamento != null)
      {
        let MaxAdattamentoAsseY = 0
        let MinAdattamentoAsseY = 0

        for(let i = 0; i < this.OggettoTotaleSpostamento.ListaTotaliSpostamento.length; i++)
        {
          if(MaxAdattamentoAsseY < this.OggettoTotaleSpostamento.ListaTotaliSpostamento[i].SpostamentoTotale)
            MaxAdattamentoAsseY = this.OggettoTotaleSpostamento.ListaTotaliSpostamento[i].SpostamentoTotale
          if(MinAdattamentoAsseY > this.OggettoTotaleSpostamento.ListaTotaliSpostamento[i].SpostamentoTotale)
            MinAdattamentoAsseY = this.OggettoTotaleSpostamento.ListaTotaliSpostamento[i].SpostamentoTotale
        }

        if(MaxAdattamentoAsseY == MinAdattamentoAsseY)
        {
          if(MinAdattamentoAsseY == 0)
          {
            MaxAdattamentoAsseY = 0.1; 
            MinAdattamentoAsseY = -0.1;
          }
          else MaxAdattamentoAsseY = MinAdattamentoAsseY + Math.abs(MinAdattamentoAsseY / 10);
        }
        
        let UdmY = Math.abs(MaxAdattamentoAsseY - MinAdattamentoAsseY) / 10

        if(UdmY < 0.1)
        {
          UdmY = TZMathFunct.GetMultiplo(UdmY, 0.01, 'Eccesso')
          UdmY = Number(UdmY.toFixed(2))
        }
        else
        {
          UdmY = TZMathFunct.GetMultiplo(UdmY, 0.1, 'Eccesso')
          UdmY = Number(UdmY.toFixed(1))
        }

        if(UdmY < 0.01)
          UdmY = 0.01;

        this.CurrentOggettoTotaleSpostamento.MaxAdattamentoAsseYSpost = MaxAdattamentoAsseY
        this.CurrentOggettoTotaleSpostamento.MinAdattamentoAsseYSpost = MinAdattamentoAsseY
        this.CurrentOggettoTotaleSpostamento.UdmYSpost                = UdmY

        if(MaxAdattamentoAsseY < 0.1)
          MaxAdattamentoAsseY = TZMathFunct.GetMultiplo(MaxAdattamentoAsseY, 0.01, 'Eccesso')
        else MaxAdattamentoAsseY = TZMathFunct.GetMultiplo(MaxAdattamentoAsseY, 0.1, 'Eccesso')

        if(MinAdattamentoAsseY < 0.1)
          MinAdattamentoAsseY = TZMathFunct.GetMultiplo(MinAdattamentoAsseY, 0.01, 'Eccesso')
        else MinAdattamentoAsseY = TZMathFunct.GetMultiplo(MinAdattamentoAsseY, 0.1, 'Eccesso')


        MaxAdattamentoAsseY  = Number(MaxAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(MaxAdattamentoAsseY))))
        MinAdattamentoAsseY  = Number(MinAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(MinAdattamentoAsseY))))

        ObjGrafico.AxisY.Min = MinAdattamentoAsseY
        ObjGrafico.AxisY.Max = MaxAdattamentoAsseY
        ObjGrafico.AxisY.Udm = UdmY
                
        if(!IsGraficoVerticale)
          this.PressAdatta++
        else this.Disegna()
      }
      else 
      {
        let MaxAdattamentoAsseY = 0
        let MinAdattamentoAsseY = 0

        if(this.IsVelocita || this.IsVelocitaGiornaliera)
        {
          for(let i = 0; i < this.Modulo.Dati.length; i++)
          {
            if(MaxAdattamentoAsseY < this.Modulo.Dati[i].Velocita)
              MaxAdattamentoAsseY = this.Modulo.Dati[i].Velocita
            if(MinAdattamentoAsseY > this.Modulo.Dati[i].Velocita)
              MinAdattamentoAsseY = this.Modulo.Dati[i].Velocita
          }
        }
        else 
        {
          if(this.IsAccelerazione || this.IsAccelerazioneGiornaliera)
          {
            for(let i = 0; i < this.Modulo.Dati.length; i++)
            {
              if(MaxAdattamentoAsseY < this.Modulo.Dati[i].Accelerazione)
                MaxAdattamentoAsseY = this.Modulo.Dati[i].Accelerazione
              if(MinAdattamentoAsseY > this.Modulo.Dati[i].Accelerazione)
                MinAdattamentoAsseY = this.Modulo.Dati[i].Accelerazione
            }
          }
          else
          {
            for(let i = 0; i < this.Modulo.Dati.length; i++)
            {
              if(MaxAdattamentoAsseY < this.Modulo.Dati[i].Spostamento)
                MaxAdattamentoAsseY = this.Modulo.Dati[i].Spostamento
              if(MinAdattamentoAsseY > this.Modulo.Dati[i].Spostamento)
                MinAdattamentoAsseY = this.Modulo.Dati[i].Spostamento
            }
          }
        }

        if(MaxAdattamentoAsseY == MinAdattamentoAsseY)
        {
          if(MinAdattamentoAsseY == 0)
          {
            MaxAdattamentoAsseY = 0.1; 
            MinAdattamentoAsseY = -0.1;
          }
          else MaxAdattamentoAsseY = MinAdattamentoAsseY + Math.abs(MinAdattamentoAsseY / 10);
        }
        
        let UdmY = Math.abs(MaxAdattamentoAsseY - MinAdattamentoAsseY) / 10

        if(UdmY < 0.1)
          UdmY = TZMathFunct.GetMultiplo(UdmY, 0.01, 'Eccesso')
        else UdmY = TZMathFunct.GetMultiplo(UdmY, 0.1, 'Eccesso')

        if(UdmY < 0.01)
          UdmY = 0.01;

        if(this.IsVelocita || this.IsVelocitaGiornaliera)
        {
          this.CurrentModulo.MaxAdattamentoAsseYVel = MaxAdattamentoAsseY
          this.CurrentModulo.MinAdattamentoAsseYVel = MinAdattamentoAsseY
          this.CurrentModulo.UdmYVel                = UdmY
        }
        else 
        {
          if(this.IsAccelerazione || this.IsAccelerazioneGiornaliera)
          {
            this.CurrentModulo.MaxAdattamentoAsseYAccel = MaxAdattamentoAsseY
            this.CurrentModulo.MinAdattamentoAsseYAccel = MinAdattamentoAsseY
            this.CurrentModulo.UdmYAccel                = UdmY
          }
          else
          {
            this.CurrentModulo.MaxAdattamentoAsseYSpost = MaxAdattamentoAsseY
            this.CurrentModulo.MinAdattamentoAsseYSpost = MinAdattamentoAsseY
            this.CurrentModulo.UdmYSpost                = UdmY
          }
        }

        if(MaxAdattamentoAsseY < 0.1)
          MaxAdattamentoAsseY = TZMathFunct.GetMultiplo(MaxAdattamentoAsseY, 0.01, 'Eccesso')
        else MaxAdattamentoAsseY = TZMathFunct.GetMultiplo(MaxAdattamentoAsseY, 0.1, 'Eccesso')

        if(MinAdattamentoAsseY < 0.1)
          MinAdattamentoAsseY = TZMathFunct.GetMultiplo(MinAdattamentoAsseY, 0.01, 'Eccesso')
        else MinAdattamentoAsseY = TZMathFunct.GetMultiplo(MinAdattamentoAsseY, 0.1, 'Eccesso')

        MaxAdattamentoAsseY  = Number(MaxAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(MaxAdattamentoAsseY))))
        MinAdattamentoAsseY  = Number(MinAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(MinAdattamentoAsseY))))
        ObjGrafico.AxisY.Min = MinAdattamentoAsseY
        ObjGrafico.AxisY.Max = MaxAdattamentoAsseY
        ObjGrafico.AxisY.Udm = UdmY
        
        if(!IsGraficoVerticale)
          this.PressAdatta++
        else this.Disegna()
      }
    },

    MixInsSetObjGraficoSpostamenti(OggettoGrafico, ObjTotaleSpostamento, ModuloCorrente)
    {
      if(ObjTotaleSpostamento != null)
      {
        setTimeout(()=>
        {
          OggettoGrafico.AxisY.Max = ObjTotaleSpostamento.MaxAdattamentoAsseYSpost
          OggettoGrafico.AxisY.Min = ObjTotaleSpostamento.MinAdattamentoAsseYSpost
          OggettoGrafico.AxisY.Udm = ObjTotaleSpostamento.UdmYSpost
        }, 1000)
        
      }
      else
      {
        if(this.IsVelocita || this.IsVelocitaGiornaliera)
        {
          if(ModuloCorrente.MaxAdattamentoAsseYVel != undefined)
            ModuloCorrente.MaxAdattamentoAsseYVel = Number(ModuloCorrente.MaxAdattamentoAsseYVel.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseYVel))))
          if(ModuloCorrente.MinAdattamentoAsseYVel != undefined)
            ModuloCorrente.MinAdattamentoAsseYVel = Number(ModuloCorrente.MinAdattamentoAsseYVel.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MinAdattamentoAsseYVel))))
          if(ModuloCorrente.UdmYVel != undefined)
            ModuloCorrente.UdmYVel                = Number(ModuloCorrente.UdmYVel.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.UdmYVel))))
          OggettoGrafico.AxisY.Max = ModuloCorrente.MaxAdattamentoAsseYVel
          OggettoGrafico.AxisY.Min = ModuloCorrente.MinAdattamentoAsseYVel
          OggettoGrafico.AxisY.Udm = ModuloCorrente.UdmYVel               
        }
        else if(this.IsAccelerazione || this.IsAccelerazioneGiornaliera)
        {
          if(ModuloCorrente.MaxAdattamentoAsseYVel != undefined)
            ModuloCorrente.MaxAdattamentoAsseYAccel = Number(ModuloCorrente.MaxAdattamentoAsseYAccel.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseYAccel))))
          if(ModuloCorrente.MinAdattamentoAsseYVel != undefined)
            ModuloCorrente.MinAdattamentoAsseYAccel = Number(ModuloCorrente.MinAdattamentoAsseYAccel.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MinAdattamentoAsseYAccel))))
          if(ModuloCorrente.UdmYAccel != undefined)
            ModuloCorrente.UdmYAccel                = Number(ModuloCorrente.UdmYAccel.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.UdmYAccel))))
          OggettoGrafico.AxisY.Max = ModuloCorrente.MaxAdattamentoAsseYAccel
          OggettoGrafico.AxisY.Min = ModuloCorrente.MinAdattamentoAsseYAccel
          OggettoGrafico.AxisY.Udm = ModuloCorrente.UdmYAccel               
        }
        else
        {
          if(ModuloCorrente.MaxAdattamentoAsseYSpost != undefined)
            ModuloCorrente.MaxAdattamentoAsseYSpost = Number(ModuloCorrente.MaxAdattamentoAsseYSpost.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseYSpost))))
          if(ModuloCorrente.MinAdattamentoAsseYSpost != undefined)
            ModuloCorrente.MinAdattamentoAsseYSpost = Number(ModuloCorrente.MinAdattamentoAsseYSpost.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MinAdattamentoAsseYSpost))))
          if(ModuloCorrente.UdmYSpost != undefined)
            ModuloCorrente.UdmYSpost                = Number(ModuloCorrente.UdmYSpost.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.UdmYSpost))))
          OggettoGrafico.AxisY.Max = ModuloCorrente.MaxAdattamentoAsseYSpost
          OggettoGrafico.AxisY.Min = ModuloCorrente.MinAdattamentoAsseYSpost
          OggettoGrafico.AxisY.Udm = ModuloCorrente.UdmYSpost
        }
      }
  
      let AxisX                         = {}
      AxisX.TipoUdmX                    = TIPI_UDM_X.Giorni
      AxisX.UdmX                        = 1
      AxisX.Modificato                  = false
      OggettoGrafico.AxisX             = AxisX
  
      OggettoGrafico.ListaRighelli     = []
      OggettoGrafico.TipoUdmX          = 0
      OggettoGrafico.UdmX              = 1
      
      this.DataTablePopup               = new TDataTableSegmenti(this.GetTraduzioneLabel, this.LinguaUtente)

    },
    
    MixInsConfermaPopupUdmXSpostamenti(ObjGrafico, IsGraficoVerticale = false)
    {
      ObjGrafico.AxisX.Modificato = true
      this.PopupUdmX = false
      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
    },

    MixInsEsportaComePDF(Modulo, IsGraficoVerticale = false, ObjDatiGrafici, IdModulo, IsPiezo = false, IsEst = false, SingoloGrafico = true)
    {
      this.ObjParametriPDF = []
      let TotaleStampato = false
      let DataOdierna = new Date()      

      for(let i = 0; i < Modulo.length; i++)
      {
        if(Modulo == -1 && this.TipoGrafico == this.TipiStorici.EV_ACCELEROMETRICI_CRONOLOGIA)
        {
          this.ObjParametriPDF.push(this.MixInsGetDatiPerPDF(IsGraficoVerticale, Modulo[i], ObjDatiGrafici[i], Modulo[i].ListaFalde ? Modulo[i].ListaFalde[0] : [], IdModulo.Modulo))
        }

        if(this.TipoGrafico == this.TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE)
        {
          if(((IdModulo.Modulo == Modulo[i].Modulo && IdModulo.Millisecondi == Modulo[i].Millisecondi) || IdModulo.Modulo == -1 || IdModulo.Modulo == -2) && !Modulo[i].IsPiezometro && !Modulo[i].IsEstensimetro && !TotaleStampato)
          {
            this.ObjParametriPDF.push(this.MixInsGetDatiPerPDF(IsGraficoVerticale, Modulo[i], ObjDatiGrafici[i], Modulo[i].ListaFalde ? Modulo[i].ListaFalde[0] : [], IdModulo.Modulo))
          }
          if (IdModulo.Modulo == undefined)
          {
            this.ObjParametriPDF.push(this.MixInsGetDatiPerPDF(IsGraficoVerticale, Modulo[i], ObjDatiGrafici[i], Modulo[i].ListaFalde ? Modulo[i].ListaFalde[0] : [], null))
          }
          if (this.ObjParametriPDF.length > 0)
            this.ObjParametriPDF.ListaRighelli = this.ObjParametriPDF[0].ObjDatiGraficiX.ListaRighelli
        }
        else
        {
          if(this.TipoGrafico == this.TipiStorici.CAMPIONI_RILEVATI)
          {
            // Questa fa tutti gli inclinometri
            if((IdModulo == Modulo[i].Id || IdModulo == -1 || IdModulo == -2) && Modulo[i].IsPiezometro == IsPiezo && Modulo[i].IsEstensimetro == IsEst && !TotaleStampato && SingoloGrafico)
              this.ObjParametriPDF.push(this.MixInsGetDatiPerPDF(IsGraficoVerticale, Modulo[i], ObjDatiGrafici[i], Modulo[i].ListaFalde ? Modulo[i].ListaFalde[0] : [], IdModulo))
            
            // Questa fa tutti i piezometri ed estensimetri
            if((IdModulo == Modulo[i].Id || IdModulo == -1 || IdModulo == -2)  && !TotaleStampato && !SingoloGrafico)
              this.ObjParametriPDF.push(this.MixInsGetDatiPerPDF(IsGraficoVerticale, Modulo[i], ObjDatiGrafici[i], Modulo[i].ListaFalde ? Modulo[i].ListaFalde[0] : [], IdModulo))
          }
          else
          {
            if((IdModulo == Modulo[i].Id || IdModulo == -1 || IdModulo == -2) && !Modulo[i].IsPiezometro && !Modulo[i].IsEstensimetro && !TotaleStampato)
            this.ObjParametriPDF.push(this.MixInsGetDatiPerPDF(IsGraficoVerticale, Modulo[i], ObjDatiGrafici[i], Modulo[i].ListaFalde ? Modulo[i].ListaFalde[0] : [], IdModulo))
          }
        }
        if(IdModulo == -2)
          TotaleStampato = true
      }

      let NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_GRAF_PDF',this.LinguaUtente) + '_' + TZDateFunct.FormatDateTime('yyyy_mm_dd', DataOdierna) + this.ObjParametriPDF.NomePDF + '.pdf'

      if(this.ObjParametriPDF[0] != undefined)
        NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_GRAF_PDF',this.LinguaUtente) + '_' + TZDateFunct.FormatDateTime('yyyy_mm_dd', DataOdierna) + this.ObjParametriPDF[0].NomePDF + '.pdf'
        
      setTimeout(()=>
      {
        let VettoreGrafici = []

        for (let i = 0; i < this.ObjParametriPDF.length; i++)
        {
          let ObjGrafico =  {
                              ChiaveCatena    : this.ObjDati.IdCatena,
                              TipoElementoPDF : this.ObjParametriPDF[i].TipoElementoPDF,
                              Dati            : this.ObjParametriPDF[i]
                            }
  
          VettoreGrafici.push(ObjGrafico)
        }

        SystemInformation.AdvQuerySiti.ExecuteExternalScript('StampaPDFAll',  { 
                                                                                ChiaveSito   : this.ObjDati.IdSito,
                                                                                VettoreDati  : VettoreGrafici
                                                                              },
                                                        function(Result)
                                                        {
                                                          // 'data:application/pdf;base64,' +
                                                          saveAs(TZStringConvFunct.Base64AsBlob(Result.PDF), NomeGrafico)
                                                        },
                                                        function(HTTPError,SubHTTPError,Response)
                                                        {
                                                          SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                        })
      }, 300)
    },

    MixInsElaboraDatiPDF(ObjParametriPDF, Modulo, ObjDatiGrafici, ArrayListaFalde = [])
    {
      let VettoreGrafici = []
      if (ObjParametriPDF.TipoStorico != TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SUP_SOGLIE)
      {
        if (Modulo != -1)
        {
          if (ObjParametriPDF.SingleGrafico != undefined)
            ObjParametriPDF.SingleGrafico = true
          if (Modulo == -2 && !(this.TipoGrafico == this.TipiStorici.ASSORBIMENTO || this.TipoGrafico == this.TipiStorici.TENSIONE_ALIMENTAZIONE))
          {
            let TotaleListaModuli = []
            let ObjModulo = null

            if(this.ListaModuli != undefined && this.ListaModuli.length > 0 && this.Catena == undefined)
            {
              for(let i = 0; i < this.ListaModuli.length; i++)
              {
                ObjModulo = {Id : this.ListaModuli[i].Id, Profondita : this.ListaModuli[i].Profondita, DatiGrafici : ObjDatiGrafici, ListaFalde : []}
                TotaleListaModuli.push(ObjModulo)
              }
            }

            // if(this.ModuliMostrati)
            // {
            //   for(let i = 0; i < this.ModuliMostrati.length; i++)
            //   {
            //     ObjModulo = {Id : this.ModuliMostrati[i].Id, Profondita : this.ModuliMostrati[i].Profondita, DatiGrafici : ObjDatiGrafici, ListaFalde : []}
            //     TotaleListaModuli.push(ObjModulo)
            //   }
            // }

            if(this.Catena != undefined)
            {
              if(this.Catena.Sensori != undefined && this.Catena.Sensori.length > 0)
              {
                for(let i = 0; i < this.Catena.Sensori.length; i++)
                {
                  ObjModulo = {Id : this.Catena.Sensori[i].Id, Profondita : this.Catena.Sensori[i].Profondita, DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
                  TotaleListaModuli.push(ObjModulo)
                }
              }
              
            }

            ObjParametriPDF.MostraTotale        = true
            ObjParametriPDF.MostraSingoloTotale = true
            VettoreGrafici = TotaleListaModuli 
          }
          else
          {
            if(this.TipoGrafico == this.TipiStorici.ASSORBIMENTO || this.TipoGrafico == this.TipiStorici.TENSIONE_ALIMENTAZIONE)
            {
              VettoreGrafici = ObjParametriPDF.ModuliConsiderati
            }
            else
            {
              VettoreGrafici = ObjParametriPDF.ModuliConsiderati.filter((element) =>
              {
                return element.Id == Modulo
              })
            }
          }
          ObjParametriPDF.ModuliConsiderati = VettoreGrafici
        }
        else 
        {
          if (ObjParametriPDF.TipoStorico == TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SEPARATI || 
              ObjParametriPDF.TipoStorico == TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_ORARIA        ||
              ObjParametriPDF.TipoStorico == TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_GIORNALIERA   ||
              ObjParametriPDF.TipoStorico == TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_ORARIA   ||
              ObjParametriPDF.TipoStorico == TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_GIORNALIERA)
            ObjParametriPDF.MostraTotale = true
        }
      }
      else
      {
        let Evento = Modulo
        if (Evento != -1 && JSON.stringify(Evento) != '{}' && ObjParametriPDF.Separati)
        {
          // let EventoConsiderato = this.ListaSuperamentiSoglia.find((element) =>
          // {
          //   return element.Id == Evento.DataEffettiva
          // })
          let VettoreGrafici = ObjParametriPDF.ModuliConsiderati.filter((element) =>
          {
            return element.Id == Evento.Modulo && element.Data == Evento.DataEffettiva && element.Millisecondi == Evento.Millisecondi
          })
          ObjParametriPDF.ModuliConsiderati = VettoreGrafici
          ObjParametriPDF.DataDal = Evento.MinData
          ObjParametriPDF.DataAl = TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn:ss', (new Date((new Date (Evento.MinData)).getTime() + this.Stacking * 1000)))
        }
        else
        {
          ObjParametriPDF.DataDal = ObjParametriPDF.DataEffettiva
          ObjParametriPDF.DataAl = TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn:ss', (new Date((new Date (ObjParametriPDF.DataEffettiva)).getTime() + this.Stacking * 1000)))
        }
      }
      if(ObjParametriPDF.ModuliConsiderati  != undefined)
        for(let i = 0; i < ObjParametriPDF.ModuliConsiderati.length; i++)
        {
          if(ObjParametriPDF.ModuliConsiderati[i].DatiGrafici != undefined && ObjParametriPDF.ModuliConsiderati[i].DatiGrafici.AxisX != undefined)
          {
            ObjParametriPDF.ModuliConsiderati[i].DatiGrafici.AxisX.Min = TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn:ss', (new Date((new Date (ObjParametriPDF.ModuliConsiderati[i].DatiGrafici.AxisX.Min)).getTime() + this.Stacking * 1000)))
            ObjParametriPDF.ModuliConsiderati[i].DatiGrafici.AxisX.Max = TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn:ss', (new Date((new Date (ObjParametriPDF.ModuliConsiderati[i].DatiGrafici.AxisX.Max)).getTime() + this.Stacking * 1000)))
          }
        }
    },

    MixInsGetDatiPerPDF(IsGraficoVerticale, Modulo, ObjDatiGrafici, ArrayListaFalde = [], IdModulo = null)
    {
      let ObjParametri = {}
      let ModuliPerAccSovrapposti = []
      let IsGraficoTotale = false
      ObjParametri.TipoElementoPDF = TIPO_ELEMENTO_PDF.ELEMENTO_STORICO
      let DataDal = this.ObjDal.Data
      let OraDal = this.ObjDal.Ora
      if (OraDal < 10)
      {
        OraDal = '0' + OraDal
      }
      DataDal = DataDal + ' ' + OraDal + ':00:00'
      let DataAl = this.ObjAl.Data
      let OraAl = this.ObjAl.Ora
      if (OraAl < 10)
      {
        OraAl = '0' + OraAl
      }
      DataAl = DataAl + ' ' + OraAl + ':00:00'
      let NomePDF = ''
      let GraficoLinee = 'imgLine'
      let NomeGrafico = ''
      let ObjModulo = null
      
      ObjParametri.ModuliConsiderati = []
      ObjParametri.ColoreGrafico       = null
      
      switch (this.TipoGrafico)
      {
        case (this.TipiStorici.EV_ACCELEROMETRICI_SINTETICI_A) :
        {
          let ProfonditaSensore = Modulo.ProfonditaCoda ? Modulo.ProfonditaCoda : Modulo.Profondita
          ObjModulo = {Id : Modulo.Id, Profondita : Number(ProfonditaSensore), DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_EV_ACC_A',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_EV_ACC_A',this.LinguaUtente)          

          if(this.ColoreFreq)
          {
            if(this.ColoreFreq.startsWith('rgb'))
              ObjParametri.ColoreGrafico    = TZGenericFunct.GetHexColorFromRGB(this.ColoreFreq)
            else ObjParametri.ColoreGrafico = this.ColoreFreq
          }

          if(Modulo.NewColorAmpiezzaX)
          {
            if(Modulo.NewColorAmpiezzaX.startsWith('rgb'))
              ObjParametri.ColoreGraficoX    = TZGenericFunct.GetHexColorFromRGB(Modulo.NewColorAmpiezzaX)
            else ObjParametri.ColoreGraficoX = Modulo.NewColorAmpiezzaX
          }

          if(Modulo.NewColorAmpiezzaY)
          {
            if(Modulo.NewColorAmpiezzaY.startsWith('rgb'))
              ObjParametri.ColoreGraficoY    = TZGenericFunct.GetHexColorFromRGB(Modulo.NewColorAmpiezzaY)
            else ObjParametri.ColoreGraficoY = Modulo.NewColorAmpiezzaY
          }

          if(Modulo.NewColorAmpiezzaZ)
          {
            if(Modulo.NewColorAmpiezzaZ.startsWith('rgb'))
              ObjParametri.ColoreGraficoZ    = TZGenericFunct.GetHexColorFromRGB(Modulo.NewColorAmpiezzaZ)
            else ObjParametri.ColoreGraficoZ = Modulo.NewColorAmpiezzaZ
          }

          if(Modulo.Soglie != undefined && Modulo.Soglie.CfgSMS1 != undefined)
          {
            if(Modulo.Soglie.CfgSMS1.Colore.startsWith('rgb'))
              ObjParametri.ColoreSogliaSMS1    = TZGenericFunct.GetHexColorFromRGB(Modulo.Soglie.CfgSMS1.Colore)
            else ObjParametri.ColoreSogliaSMS1 = Modulo.Soglie.CfgSMS1.Colore
          }

          if(Modulo.Soglie != undefined && Modulo.Soglie.CfgSMS2 != undefined)
          {
            if(Modulo.Soglie.CfgSMS2.Colore.startsWith('rgb'))
              ObjParametri.ColoreSogliaSMS2    = TZGenericFunct.GetHexColorFromRGB(Modulo.Soglie.CfgSMS2.Colore)
            else ObjParametri.ColoreSogliaSMS2 = Modulo.Soglie.CfgSMS2.Colore
          }

          if(Modulo.Soglie != undefined && Modulo.Soglie.CfgSMS3 != undefined)
          {
            if(Modulo.Soglie.CfgSMS3.Colore.startsWith('rgb'))
              ObjParametri.ColoreSogliaSMS3    = TZGenericFunct.GetHexColorFromRGB(Modulo.Soglie.CfgSMS3.Colore)
            else ObjParametri.ColoreSogliaSMS3 = Modulo.Soglie.CfgSMS3.Colore
          }

          if(Modulo.Soglie != undefined && Modulo.Soglie.CfgSMS4 != undefined)
          {
            if(Modulo.Soglie.CfgSMS4.Colore.startsWith('rgb'))
              ObjParametri.ColoreSogliaSMS4    = TZGenericFunct.GetHexColorFromRGB(Modulo.Soglie.CfgSMS4.Colore)
            else ObjParametri.ColoreSogliaSMS4 = Modulo.Soglie.CfgSMS4.Colore
          }

          if(Modulo.Soglie != undefined && Modulo.Soglie.CfgAllarme != undefined)
          {
            if(Modulo.Soglie.CfgAllarme.Colore.startsWith('rgb'))
              ObjParametri.ColoreSogliaAllarme    = TZGenericFunct.GetHexColorFromRGB(Modulo.Soglie.CfgAllarme.Colore)
            else ObjParametri.ColoreSogliaAllarme = Modulo.Soglie.CfgAllarme.Colore
          }

          if(Modulo.Soglie != undefined && Modulo.Soglie.CfgRilevamento != undefined)
          {
            if(Modulo.Soglie.CfgRilevamento.Colore.startsWith('rgb'))
              ObjParametri.ColoreSogliaRilevamento    = TZGenericFunct.GetHexColorFromRGB(Modulo.Soglie.CfgRilevamento.Colore)
            else ObjParametri.ColoreSogliaRilevamento = Modulo.Soglie.CfgRilevamento.Colore
          }
          break
        }
        case (this.TipiStorici.EV_ACCELEROMETRICI_SINTETICI_F) :
        {
          let ProfonditaSensore = Modulo.ProfonditaCoda ? Modulo.ProfonditaCoda : Modulo.Profondita
          ObjModulo = {Id : Modulo.Id, Profondita : Number(ProfonditaSensore), DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
          NomeGrafico = this.GetTraduzioneLabel('VUEComponenteGraficoAccelerometri','TKN_GRAF_ACCEL_FRQ',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_EV_ACC_F',this.LinguaUtente)

          if(this.ColoreFreq)
          {
            if(this.ColoreFreq.startsWith('rgb'))
              ObjParametri.ColoreGrafico    = TZGenericFunct.GetHexColorFromRGB(this.ColoreFreq)
            else ObjParametri.ColoreGrafico = this.ColoreFreq
          }

          if(Modulo.NewColorFrequenza)
          {
            if(Modulo.NewColorFrequenza.startsWith('rgb'))
              ObjParametri.ColoreGrafico    = TZGenericFunct.GetHexColorFromRGB(Modulo.NewColorFrequenza)
            else ObjParametri.ColoreGrafico = Modulo.NewColorFrequenza
          }

          break
        }
        case (this.TipiStorici.EV_ACCELEROMETRICI_CRONOLOGIA) :
        {
          ObjParametri.Stacking = this.Stacking
          ObjParametri.UseAmpiezza = this.GraficiAmpiezza
          ObjParametri.ColoriAllarmi = []
          ObjModulo = {Id : Modulo.Id, Profondita : Modulo.Profondita, DatiGrafici : ObjDatiGrafici, ListaFalde : []}
          let Allarmi = this.GraficiAmpiezza ? this.LivelliAllarme.Ampiezza : this.LivelliAllarme.Frequenza
          ObjParametri.ColoriAllarmi.push({Colore: COLORI_ALLARME_CRONOLOGIA_ACC.Livello0, Intensita: 0})
          ObjParametri.ColoriAllarmi.push({Colore: COLORI_ALLARME_CRONOLOGIA_ACC.Livello1, Intensita: Allarmi.Primo})
          ObjParametri.ColoriAllarmi.push({Colore: COLORI_ALLARME_CRONOLOGIA_ACC.Livello2, Intensita: Allarmi.Secondo})
          ObjParametri.ColoriAllarmi.push({Colore: COLORI_ALLARME_CRONOLOGIA_ACC.Livello3, Intensita: Allarmi.Terzo})
          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_CRON_EV_ACC',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_CRON_EV_ACC',this.LinguaUtente)
          break
        }
        case (this.TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE) :
        {
          ObjParametri.LegendaSovrapposti = Modulo.LegendaSovrapposti
          ObjParametri.DataMin            = Modulo.DataMin
          ObjParametri.DataEffettiva      = Modulo.DataEffettiva
          ObjParametri.ObjDatiGraficiX    = Modulo.ObjDatiGraficiX
          ObjParametri.ObjDatiGraficiY    = Modulo.ObjDatiGraficiY
          ObjParametri.ObjDatiGraficiZ    = Modulo.ObjDatiGraficiZ
          ObjParametri.Separati = !this.EventiSovrapposti
          ObjParametri.Stacking = this.Stacking
          ObjParametri.Relativi = this.Relativo
          ObjParametri.Millisecondi = Modulo.Millisecondi

          if (!this.EventiSovrapposti)
            ObjModulo = {Id : Modulo.Modulo, Data: Modulo.DataEffettiva, Millisecondi : Modulo.Millisecondi, Profondita : Modulo.Profondita,  DatiGraficiX : Modulo.ObjDatiGraficiX, DatiGraficiY : Modulo.ObjDatiGraficiY, DatiGraficiZ : Modulo.ObjDatiGraficiZ}
          else
          {
            let LastModulo = -1
            for (let i = 0; i < Modulo.ListaModuli.length; i++)
            {
              let SingleModulo = Modulo.ListaModuli[i]
              if (SingleModulo.Modulo != LastModulo)
              {
                // ModuliPerAccSovrapposti.push({Id : SingleModulo.Modulo, Data: SingleModulo.DataEffettiva, Profondita : SingleModulo.Profondita})
                ModuliPerAccSovrapposti.push({Id : SingleModulo.Modulo, Profondita : SingleModulo.Profondita})
                LastModulo = SingleModulo.Modulo
              }
            }
          }

          let DataFormattata = this.FormattaData(Modulo.DataEffettiva) + '.' + Modulo.Millisecondi
          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_EV_ACC_SUP_S',this.LinguaUtente) + ' del ' +  DataFormattata 
          if (Modulo.Modulo != -1)
            NomeGrafico = NomeGrafico + ' - '  + 'Modulo nr.' + Modulo.Modulo

          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_EV_ACC_SUP_S',this.LinguaUtente)
          break
        }
        case (this.TipiStorici.CAMPIONI_RILEVATI) :
        {
          ObjModulo = {Id : Modulo.Id, Profondita : Modulo.Profondita, ProfonditaCoda : Modulo.ProfonditaCoda, DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
          NomeGrafico  = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_CAMP_RIL',this.LinguaUtente)
          NomePDF      = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_CAMP_RIL',this.LinguaUtente)
          ObjParametri.IsPiezometro   = Modulo.IsPiezometro   != undefined ? Modulo.IsPiezometro   : (Modulo.Piezometro   != undefined ? Modulo.Piezometro   : false)
          ObjParametri.IsEstensimetro = Modulo.IsEstensimetro != undefined ? Modulo.IsEstensimetro : (Modulo.Estensimetro != undefined ? Modulo.Estensimetro : false)
          
          if(Modulo.ShowRoll != null)
            ObjParametri.ShowRoll = Modulo.ShowRoll
          if(Modulo.ShowPitch != null)
            ObjParametri.ShowPitch = Modulo.ShowPitch
          if(Modulo.ShowTemp != null)
            ObjParametri.ShowTemp = Modulo.ShowTemp

          if(this.ColorePitch)
          {
            if(this.ColorePitch.startsWith('rgb'))
              ObjParametri.ColorePitch    = TZGenericFunct.GetHexColorFromRGB(this.ColorePitch)
            else ObjParametri.ColorePitch = this.ColorePitch
          }

          if(this.ColoreRoll)
          {
            if(this.ColoreRoll.startsWith('rgb'))
              ObjParametri.ColoreRoll    = TZGenericFunct.GetHexColorFromRGB(this.ColoreRoll)
            else ObjParametri.ColoreRoll = this.ColoreRoll
          }

          if(this.ColoreTemp)
          {
            if(this.ColoreTemp.startsWith('rgb'))
              ObjParametri.ColoreTemp    = TZGenericFunct.GetHexColorFromRGB(this.ColoreTemp)
            else ObjParametri.ColoreTemp = this.ColoreTemp
          }

          if(this.ColorePiezo)
          {
            if(this.ColorePiezo.startsWith('rgb'))
              ObjParametri.ColorePiezo    = TZGenericFunct.GetHexColorFromRGB(this.ColorePiezo)
            else ObjParametri.ColorePiezo = this.ColorePiezo
          }

          if(this.ColoreDef)
          {
            if(this.ColoreDef.startsWith('rgb'))
              ObjParametri.ColoreDef    = TZGenericFunct.GetHexColorFromRGB(this.ColoreDef)
            else ObjParametri.ColoreDef = this.ColoreDef
          }

          break
        }
        case (this.TipiStorici.SPOSTAMENTI_GRAFICI_SEPARATI) :
        {
          ObjParametri.MostraTotale        = false
          ObjParametri.MostraSingoloTotale = false  
          ObjParametri.SingleGrafico       = true
          ObjParametri.PrintAllGraph       = IdModulo == -1
          ObjParametri.SegmentiVelocita    = ObjDatiGrafici.SegmentiVelocita

          if(this.ColoreModulo)
          {
            if(this.ColoreModulo.startsWith('rgb'))
              ObjParametri.ColoreGrafico    = TZGenericFunct.GetHexColorFromRGB(this.ColoreModulo)
            else ObjParametri.ColoreGrafico = this.ColoreModulo
          }

          ObjModulo = {Id : Modulo.Id, Profondita : Modulo.Profondita, ProfonditaCoda : Modulo.ProfonditaCoda, DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
          
          if(!IsGraficoVerticale || this.OggettoTotaleSpostamento != undefined)
          {
            if(IsGraficoVerticale)
              IsGraficoTotale = true
            let DatiGraficiTotale = IsGraficoVerticale ? this.OggettoTotaleSpostamento : TZGenericFunct.GetCopyOfObject(this.Catena.OggettoTotaleSpostamento)
            ObjParametri.DatiGraficiTotale = {
                                               MaxAdattamentoAsseYSpost : DatiGraficiTotale.MaxAdattamentoAsseYSpost,
                                               MaxProfondita            : DatiGraficiTotale.MaxProfondita,
                                               MinAdattamentoAsseYSpost : DatiGraficiTotale.MinAdattamentoAsseYSpost,
                                               MinProfondita            : DatiGraficiTotale.MinProfondita,
                                               UdmYSpost                : DatiGraficiTotale.UdmYSpost
                                             }
          }

          ObjParametri.Orientamento = this.ObjDati.OrientamentoAsse
          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_SPOST_SEP',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_SPOST_SEP',this.LinguaUtente)
          break
        }
        case (this.TipiStorici.SPOSTAMENTI_GRAFICI_SOVR) :
        {
          ObjParametri.Orientamento = this.ObjDati.OrientamentoAsse
          ObjParametri.DettagliGrafico = Modulo.DettagliGrafico
          ObjParametri.Legenda = Modulo.Legenda

          if(this.ColoreModulo != null)
            ObjParametri.ColoreGrafico    = this.ColoreModulo
          else ObjParametri.ColoreGrafico = '#0000ff'

          ObjModulo = {Id : Modulo.Id, Profondita : Modulo.Profondita, DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_SPOST_SOVR',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_SPOST_SOVR',this.LinguaUtente)
          break
        }
        case (this.TipiStorici.VELOCITA_MEDIA_ORARIA) :
        {
          ObjParametri.MostraTotale        = false 
          ObjParametri.MostraSingoloTotale = false 

          if(this.ColoreModulo)
          {
            if(this.ColoreModulo.startsWith('rgb'))
              ObjParametri.ColoreGrafico    = TZGenericFunct.GetHexColorFromRGB(this.ColoreModulo)
            else ObjParametri.ColoreGrafico = this.ColoreModulo
          }
          
          ObjModulo = {Id : Modulo.Id, Profondita : Modulo.Profondita, ProfonditaCoda : Modulo.ProfonditaCoda, DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
          
          if(!IsGraficoVerticale || this.OggettoTotaleSpostamento != undefined)
          {
            if(IsGraficoVerticale)
              IsGraficoTotale = true
            let DatiGraficiTotale = IsGraficoVerticale ? this.OggettoTotaleSpostamento : TZGenericFunct.GetCopyOfObject(this.Catena.OggettoTotaleSpostamento)
            ObjParametri.DatiGraficiTotale = {
                                               MaxAdattamentoAsseYSpost : DatiGraficiTotale.MaxAdattamentoAsseYSpost,
                                               MaxProfondita            : DatiGraficiTotale.MaxProfondita,
                                               MinAdattamentoAsseYSpost : DatiGraficiTotale.MinAdattamentoAsseYSpost,
                                               MinProfondita            : DatiGraficiTotale.MinProfondita,
                                               UdmYSpost                : DatiGraficiTotale.UdmYSpost
                                             }
          }

          ObjParametri.Orientamento = this.ObjDati.OrientamentoAsse
          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_VEL_H',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_VEL_H',this.LinguaUtente)
          break
        }
        case (this.TipiStorici.ACCELERAZIONE_MEDIA_ORARIA) :
        {
          ObjParametri.MostraTotale        = false 
          ObjParametri.MostraSingoloTotale = false 

          if(this.ColoreModulo)
          {
            if(this.ColoreModulo.startsWith('rgb'))
              ObjParametri.ColoreGrafico    = TZGenericFunct.GetHexColorFromRGB(this.ColoreModulo)
            else ObjParametri.ColoreGrafico = this.ColoreModulo
          }

          ObjModulo = {Id : Modulo.Id, Profondita : Modulo.Profondita, ProfonditaCoda : Modulo.ProfonditaCoda, DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
          
          if(!IsGraficoVerticale || this.OggettoTotaleSpostamento != undefined)
          {
            if(IsGraficoVerticale)
              IsGraficoTotale = true
            let DatiGraficiTotale = IsGraficoVerticale ? this.OggettoTotaleSpostamento : TZGenericFunct.GetCopyOfObject(this.Catena.OggettoTotaleSpostamento)
            ObjParametri.DatiGraficiTotale = {
                                               MaxAdattamentoAsseYSpost : DatiGraficiTotale.MaxAdattamentoAsseYSpost,
                                               MaxProfondita            : DatiGraficiTotale.MaxProfondita,
                                               MinAdattamentoAsseYSpost : DatiGraficiTotale.MinAdattamentoAsseYSpost,
                                               MinProfondita            : DatiGraficiTotale.MinProfondita,
                                               UdmYSpost                : DatiGraficiTotale.UdmYSpost
                                             }
          }

          ObjParametri.Orientamento = this.ObjDati.OrientamentoAsse
          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_ACC_H',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_ACC_H',this.LinguaUtente)
          break
        }
        case (this.TipiStorici.VELOCITA_MEDIA_GIORNALIERA) :
        {
          ObjParametri.MostraTotale          = false 
          ObjParametri.MostraSingoloTotale   = false 
          ObjParametri.SogliaAllarmiPresente = ObjDatiGrafici.SogliePresenti ? ObjDatiGrafici.SogliePresenti : false
          if(this.PopupImpostaAllarmiSoglie != undefined)
            ObjParametri.DatiSoglie          = {
                                                  LivelloBlu     : this.PopupImpostaAllarmiSoglie.Soglie.Blu,
                                                  LivelloGiallo  : this.PopupImpostaAllarmiSoglie.Soglie.Giallo,
                                                  LivelloArancio : this.PopupImpostaAllarmiSoglie.Soglie.Arancio,
                                                  LivelloRosso   : this.PopupImpostaAllarmiSoglie.Soglie.Rosso
                                                }                                              

          if(this.ColoreModulo)
          {
            if(this.ColoreModulo.startsWith('rgb'))
              ObjParametri.ColoreGrafico    = TZGenericFunct.GetHexColorFromRGB(this.ColoreModulo)
            else ObjParametri.ColoreGrafico = this.ColoreModulo
          }

          ObjModulo = {Id : Modulo.Id, Profondita : Modulo.Profondita, ProfonditaCoda : Modulo.ProfonditaCoda, DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
          
          if(!IsGraficoVerticale || this.OggettoTotaleSpostamento != undefined)
          {
            if(IsGraficoVerticale)
              IsGraficoTotale = true
            let DatiGraficiTotale = IsGraficoVerticale ? this.OggettoTotaleSpostamento : TZGenericFunct.GetCopyOfObject(this.Catena.OggettoTotaleSpostamento)
            ObjParametri.DatiGraficiTotale = {
                                               MaxAdattamentoAsseYSpost : DatiGraficiTotale.MaxAdattamentoAsseYSpost,
                                               MaxProfondita            : DatiGraficiTotale.MaxProfondita,
                                               MinAdattamentoAsseYSpost : DatiGraficiTotale.MinAdattamentoAsseYSpost,
                                               MinProfondita            : DatiGraficiTotale.MinProfondita,
                                               UdmYSpost                : DatiGraficiTotale.UdmYSpost
                                             }
          }

          ObjParametri.Orientamento = this.ObjDati.OrientamentoAsse
          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_VEL_GG',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_VEL_GG',this.LinguaUtente)
          break
        }
        case (this.TipiStorici.ACCELERAZIONE_MEDIA_GIORNALIERA) :
        {
          ObjParametri.MostraTotale        = false 
          ObjParametri.MostraSingoloTotale = false 

          if(this.ColoreModulo)
          {
            if(this.ColoreModulo.startsWith('rgb'))
              ObjParametri.ColoreGrafico    = TZGenericFunct.GetHexColorFromRGB(this.ColoreModulo)
            else ObjParametri.ColoreGrafico = this.ColoreModulo
          }

          ObjModulo = {Id : Modulo.Id, Profondita : Modulo.Profondita, ProfonditaCoda : Modulo.ProfonditaCoda, DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
          
          if(!IsGraficoVerticale || this.OggettoTotaleSpostamento != undefined)
          {
            if(IsGraficoVerticale)
              IsGraficoTotale = true
            let DatiGraficiTotale = IsGraficoVerticale ? this.OggettoTotaleSpostamento : TZGenericFunct.GetCopyOfObject(this.Catena.OggettoTotaleSpostamento)
            ObjParametri.DatiGraficiTotale = {
                                               MaxAdattamentoAsseYSpost : DatiGraficiTotale.MaxAdattamentoAsseYSpost,
                                               MaxProfondita            : DatiGraficiTotale.MaxProfondita,
                                               MinAdattamentoAsseYSpost : DatiGraficiTotale.MinAdattamentoAsseYSpost,
                                               MinProfondita            : DatiGraficiTotale.MinProfondita,
                                               UdmYSpost                : DatiGraficiTotale.UdmYSpost
                                             }
          }

          ObjParametri.Orientamento = this.ObjDati.OrientamentoAsse
          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_ACC_GG',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_ACC_GG',this.LinguaUtente)
          break
        }
        case (this.TipiStorici.STAZIONE_METEO) :
        {
          ObjParametri.Orientamento    = this.ObjDati.OrientamentoAsse
          ObjParametri.DettagliGrafico = Modulo.DettagliGrafico
          ObjParametri.AltriAssi       = Modulo.AltriAssi
          
          ObjModulo = {Id : Modulo.Id, Profondita : Modulo.Profondita, DatiGrafici : ObjDatiGrafici, ListaFalde : ArrayListaFalde}
          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_STAZ_METEO',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_STAZ_METEO',this.LinguaUtente)
          break
        }
        case (this.TipiStorici.ASSORBIMENTO) :
        {
          let LsModuli = []
          if(this.ModuliMostrati)
          {
            for (let i = 0; i < this.ModuliMostrati.length; i++)
            {
              let Modulo = TZGenericFunct.GetCopyOfObject(this.ModuliMostrati[i])
              LsModuli.push(Modulo)
            }
          }

          if(this.ListaModuli)
          {
            for (let i = 0; i < this.ListaModuli.length; i++)
            {
              let Modulo = TZGenericFunct.GetCopyOfObject(this.ListaModuli[i])
              LsModuli.push(Modulo)
            }
          }
          
          ObjModulo = {DatiGrafici : ObjDatiGrafici, LsModuli : LsModuli}

          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_ASSORB',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_ASSORB',this.LinguaUtente)
          break
        }
        case (this.TipiStorici.TENSIONE_ALIMENTAZIONE) :
        {
          let LsModuli = []
          if(this.ModuliMostrati)
          {
            for (let i = 0; i < this.ModuliMostrati.length; i++)
            {
              if(this.ModuliMostrati[i].Disegna)
              {
                let Modulo = TZGenericFunct.GetCopyOfObject(this.ModuliMostrati[i])
                LsModuli.push(Modulo)
              }
            }
          }

          if(this.ListaModuli)
          {
            for (let i = 0; i < this.ListaModuli.length; i++)
            {
              if(this.ListaModuli[i].Disegna)
              {
                let Modulo = TZGenericFunct.GetCopyOfObject(this.ListaModuli[i])
                LsModuli.push(Modulo)
              }
            }
          }

          ObjModulo = {DatiGrafici : ObjDatiGrafici, LsModuli : LsModuli}

          NomeGrafico = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_TENS_ALIM',this.LinguaUtente)
          NomePDF     = this.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_NOME_GRAFICO_PDF_TENS_ALIM',this.LinguaUtente)
          break
        }
      }

      if (this.TipoGrafico == this.TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE && this.EventiSovrapposti)
        ObjParametri.ModuliConsiderati = ModuliPerAccSovrapposti
      else
        ObjParametri.ModuliConsiderati.push(ObjModulo)

      ObjParametri.DataDal = DataDal
      ObjParametri.DataAl  = DataAl
      if(!IsGraficoVerticale)
        ObjParametri.Titolo  = this.GetTraduzioneLabel('Generic','TKN_DMS',this.LinguaUtente) + ' ' + this.ObjDati.Descrizione + ': ' + NomeGrafico
      else ObjParametri.Titolo  = this.GetTraduzioneLabel('Generic','TKN_DMS',this.LinguaUtente) + ' ' + this.DescrizioneSitoPDF + ': ' + NomeGrafico
      ObjParametri.Info    = (SystemInformation.Configurazioni.Siti.find((element) => {return element.CHIAVE == this.ObjDati.IdSito})).NOME
      ObjParametri.TipoStorico = this.TipoGrafico
      ObjParametri.GraficoLinee = GraficoLinee

      // ObjParametri.DatiGrafici = this.ObjGrafico.OggettoGrafico
      // ObjParametri.DatiGrafici.DataAllineamento = ''

      ObjParametri.NomePDF = NomePDF
      ObjParametri.FusoUtente = SystemInformation.UserInformation.FusoOrario
      // ObjParametri.DataAllineamento = ''
      // if (this.InfoCatena.DatiCatena.Allineamento.Data != null)
      //   ObjParametri.DataAllineamento = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.InfoCatena.DatiCatena.Allineamento.Data))

      // if(IdModulo == -1 && Modulo.Id == undefined)
      //   this.MixInsElaboraDatiPDF(ObjParametri, -2, ObjDatiGrafici)

      if(IdModulo == -2 || IsGraficoTotale || (IdModulo == -1 && Modulo.Id == undefined)) 
          this.MixInsElaboraDatiPDF(ObjParametri, -2, ObjDatiGrafici, ArrayListaFalde)
      else 
      {
        if(this.TipoGrafico == this.TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE)
          this.MixInsElaboraDatiPDF(ObjParametri, Modulo, ObjDatiGrafici, ArrayListaFalde)
        else 
        {
          if(Modulo.Id == -1 && IdModulo == undefined)
            this.MixInsElaboraDatiPDF(ObjParametri, -1, ObjDatiGrafici)
          else this.MixInsElaboraDatiPDF(ObjParametri, Modulo.Id, ObjDatiGrafici, ArrayListaFalde)
        }
      }
      
      return ObjParametri 
    },

    FormattaData(DataDaFormattare)
    {
      let Data    = new Date(DataDaFormattare.replace(' ', 'T'));
      let Giorno  = String(Data.getDate()).padStart(2, '0');
      let Mese    = String(Data.getMonth() + 1).padStart(2, '0');
      let Anno    = Data.getFullYear();
      let Ore     = String(Data.getHours()).padStart(2, '0');
      let Minuti  = String(Data.getMinutes()).padStart(2, '0');
      let Secondi = String(Data.getSeconds()).padStart(2, '0');
      let Result  = `${Giorno}/${Mese}/${Anno} ${Ore}.${Minuti}.${Secondi}`;
      return Result
    },

    MixInsOnClickAdattaCampRil(ObjGrafico, IsGraficoVerticale = false)
    {
      ObjGrafico.AxisX.Modificato     = false
      ObjGrafico.AxisY.Modificato     = false
      ObjGrafico.AxisYTemp.Modificato = false

      let MaxAdattamentoAsseY = 0
      let MinAdattamentoAsseY = 0

      if(this.IsEstensimetro)
      {
      // if FDataAllDeform <> 0 then
      //     DeformazioneAll := SystemInformation.SorgenteDati.GetDeformazione(FCatena,FIdSensore,FDataAllDeform);
      //   GetEstremiEstensione(CfgSensore.IdSensore,Min1,Max1,FListaCampioni);
      

        let DefMax = 0
        let DefMin = 0
        for(let i = 0; i < this.Modulo.Dati.length; i++)
        {
          if(DefMax < this.Modulo.Dati[i].Deformazione)
            DefMax = this.Modulo.Dati[i].Deformazione
          if(DefMin > this.Modulo.Dati[i].Deformazione)
            DefMin = this.Modulo.Dati[i].Deformazione
        }
        
        MaxAdattamentoAsseY = DefMax
        MinAdattamentoAsseY = DefMin

        MaxAdattamentoAsseY  = Number(MaxAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(MaxAdattamentoAsseY))))
        MinAdattamentoAsseY  = Number(MinAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(MinAdattamentoAsseY)))) 
        //DEFORMAZIONE ALLINEAMENTO 
        //   Zoom.MinY := Min1 - DeformazioneAll;
        //   Zoom.MaxY := Max1 - DeformazioneAll;
      }
      else if(this.IsPiezometro)
      {
        let PressMax = 0
        let PressMin = 0
        if (this.Modulo.Dati.length > 0)
        {
          PressMax = this.Modulo.Dati[0].Pressione
          PressMin = this.Modulo.Dati[0].Pressione
        }
        for(let i = 0; i < this.Modulo.Dati.length; i++)
        {
          if(this.Modulo.Dati[i].Pressione != null)
          {
            if(PressMin > this.Modulo.Dati[i].Pressione)
            {
              PressMin = this.Modulo.Dati[i].Pressione
            }
            if(PressMax < this.Modulo.Dati[i].Pressione)
              PressMax = this.Modulo.Dati[i].Pressione
          }
        }

        let SemiWidth = (Math.abs(PressMax - PressMin) * 0.08) / 2;
        MaxAdattamentoAsseY = PressMax - this.Modulo.ProfonditaCoda + SemiWidth
        MinAdattamentoAsseY = PressMin - this.Modulo.ProfonditaCoda - SemiWidth

        MaxAdattamentoAsseY  = Number(MaxAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(MaxAdattamentoAsseY))))
        MinAdattamentoAsseY  = Number(MinAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(MinAdattamentoAsseY)))) 
      }
      else
      {
        let PitchMax = 0
        let RollMax  = 0
        let PitchMin = 0
        let RollMin  = 0

        for(let i = 0; i < this.Modulo.Dati.length; i++)
        {
          if(PitchMax < this.Modulo.Dati[i].Pitch)
            PitchMax = this.Modulo.Dati[i].Pitch
          if(RollMax < this.Modulo.Dati[i].Roll)
            RollMax = this.Modulo.Dati[i].Roll

          if(PitchMin > this.Modulo.Dati[i].Pitch)
            PitchMin = this.Modulo.Dati[i].Pitch
          if(RollMin > this.Modulo.Dati[i].Roll)
            RollMin = this.Modulo.Dati[i].Roll
        }
        
        MaxAdattamentoAsseY = PitchMax < RollMax? RollMax : PitchMax
        MinAdattamentoAsseY = PitchMin > RollMin? RollMin : PitchMin
        

        if(Math.abs(MinAdattamentoAsseY - MaxAdattamentoAsseY) < 0.06)
          MaxAdattamentoAsseY = MinAdattamentoAsseY + 0.06;

        MaxAdattamentoAsseY  = Number(MaxAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(MaxAdattamentoAsseY))))
        MinAdattamentoAsseY  = Number(MinAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(MinAdattamentoAsseY))))        
      }

      if(MaxAdattamentoAsseY == MinAdattamentoAsseY)
      {
        if(MinAdattamentoAsseY == 0)
        {
          MaxAdattamentoAsseY = 0.1; 
          MinAdattamentoAsseY = -0.1;
        }
        else MaxAdattamentoAsseY = MinAdattamentoAsseY + Math.abs(MinAdattamentoAsseY / 10);
      }

      let UdmY = Math.abs(MaxAdattamentoAsseY - MinAdattamentoAsseY) / 10

      if(UdmY < 0.1)
      {
        UdmY = TZMathFunct.GetMultiplo(UdmY, 0.01, 'Eccesso')
        UdmY = Number(UdmY.toFixed(2))
      }
      else
      {
        UdmY = TZMathFunct.GetMultiplo(UdmY, 0.1, 'Eccesso')
        UdmY = Number(UdmY.toFixed(1))
      }

      if(UdmY < 0.01)
        UdmY = 0.01;

      if(this.IsEstensimetro)
      {
        this.CurrentModulo.MaxAdattamentoAsseYDef = MaxAdattamentoAsseY
        this.CurrentModulo.MinAdattamentoAsseYDef = MinAdattamentoAsseY
        this.CurrentModulo.UdmYDef                = UdmY
      }
      else if(this.IsPiezometro)
      {
        this.CurrentModulo.MaxAdattamentoAsseYPress = MaxAdattamentoAsseY
        this.CurrentModulo.MinAdattamentoAsseYPress = MinAdattamentoAsseY
        this.CurrentModulo.UdmYPress                = UdmY
      }
      else
      {
        this.CurrentModulo.MaxAdattamentoAsseY = MaxAdattamentoAsseY
        this.CurrentModulo.MinAdattamentoAsseY = MinAdattamentoAsseY
        this.CurrentModulo.UdmY                = UdmY
      }
      
      if(MaxAdattamentoAsseY < 0.1)
        MaxAdattamentoAsseY = TZMathFunct.GetMultiplo(MaxAdattamentoAsseY, 0.01, 'Eccesso')
      else MaxAdattamentoAsseY = TZMathFunct.GetMultiplo(MaxAdattamentoAsseY, 0.1, 'Eccesso')

      if(MinAdattamentoAsseY < 0.1)
        MinAdattamentoAsseY = TZMathFunct.GetMultiplo(MinAdattamentoAsseY, 0.01, 'Eccesso')
      else MinAdattamentoAsseY = TZMathFunct.GetMultiplo(MinAdattamentoAsseY, 0.1, 'Eccesso')

      ObjGrafico.AxisY.Min = MinAdattamentoAsseY
      ObjGrafico.AxisY.Max = MaxAdattamentoAsseY
      ObjGrafico.AxisY.Udm = UdmY
      this.MixInsAnnullaPopupImpostazioniYCampRil(ObjGrafico)

      if(!IsGraficoVerticale)
        this.PressAdatta++
      else this.Disegna()
    },

    MixInsGetUnitaDiMisuraAsseYCampRil()
    {
      if(this.IsPiezometro)
        return '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MBGL',this.LinguaUtente) + ']'
      if(this.IsEstensimetro)
        return '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
      return '[' + this.GetTraduzioneLabel('UdmGenerali','TKN_SIMBOLO_GRADI',this.LinguaUtente) + ']'
    },

    MixInsConfermaPopupUdmXCampRil(ObjGrafico, IsGraficoVerticale = false)
    {
      ObjGrafico.AxisX.Modificato = true
      this.PopupUdmX = false
      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
    },

    MixInsConfermaPopupAsseTemp(ObjGrafico, IsGraficoVerticale = false)
    {
      this.CurrentModulo.MaxAdattamentoAsseTemp = ObjGrafico.AxisYTemp.Max
      this.CurrentModulo.MinAdattamentoAsseTemp = ObjGrafico.AxisYTemp.Min
      this.CurrentModulo.UdmTemp                = ObjGrafico.AxisYTemp.Udm
      ObjGrafico.AxisYTemp.Modificato      = true
      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
      this.PopupAsseTemp = false
    },

    MixInsConfermaPopupImpostazioniYCampRil(ObjGrafico, IsGraficoVerticale = false)
    {
      if(this.IsEstensimetro)
      {
        this.CurrentModulo.MaxAdattamentoAsseYDef = ObjGrafico.AxisY.Max
        this.CurrentModulo.MinAdattamentoAsseYDef = ObjGrafico.AxisY.Min
        this.CurrentModulo.UdmYDef                = ObjGrafico.AxisY.Udm
      }
      else if(this.IsPiezometro)
      {
        this.CurrentModulo.MaxAdattamentoAsseYPress = ObjGrafico.AxisY.Max
        this.CurrentModulo.MinAdattamentoAsseYPress = ObjGrafico.AxisY.Min
        this.CurrentModulo.UdmYPress                = ObjGrafico.AxisY.Udm
      }
      else
      {
        this.CurrentModulo.MaxAdattamentoAsseY = ObjGrafico.AxisY.Max
        this.CurrentModulo.MinAdattamentoAsseY = ObjGrafico.AxisY.Min
        this.CurrentModulo.UdmY                = ObjGrafico.AxisY.Udm
      }
      ObjGrafico.AxisY.Modificato       = true
      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
      this.PopupImpostazioniAsseY = false
    },

    MixInsConfermaPopupAddRighelloCampRil(ObjGrafico, IsGraficoVerticale = false)
    {
      this.PopupAddRighello = false
      this.ObjNewRighello.DateTime = this.ObjNewRighello.Data + ' ' + this.ObjNewRighello.Ora
      this.ObjNewRighello.PrettyDateTime = TZDateFunct.FormatDateTime('dd/mm/yyyy hh:nn', new Date(this.ObjNewRighello.DateTime))
      ObjGrafico.ListaRighelli.push(this.ObjNewRighello)
      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
      this.MixInsResetNewRighelloCampRil()
    },

    MixInsConfermaPopupRemoveRighelloCampRil(ObjGrafico, IsGraficoVerticale = false)
    {
      this.PopupRemoveRighello = false
      let index = ObjGrafico.ListaRighelli.findIndex((element) => {return element.PrettyDateTime == this.RighelloToRemove})
      ObjGrafico.ListaRighelli.splice(index, 1)
      if(!IsGraficoVerticale)
        this.Repaint++
      else this.DoRepaint()
    },

    MixInsResetNewRighelloCampRil()
    {
      let NewRighello            = {}
      NewRighello.Data           = ''
      NewRighello.Ora            = ''
      NewRighello.Colore         = 'black'
      NewRighello.DateTime       = ''
      NewRighello.PrettyDateTime = ''
      this.ObjNewRighello        = NewRighello
    },

    MixInsAnnullaPopupImpostazioniYCampRil(ObjGrafico)
    {
      if(this.IsEstensimetro)
      {
        ObjGrafico.AxisY.Max = this.CurrentModulo.MaxAdattamentoAsseYDef
        ObjGrafico.AxisY.Min = this.CurrentModulo.MinAdattamentoAsseYDef
        ObjGrafico.AxisY.Udm = this.CurrentModulo.UdmYDef               
      }
      else if(this.IsPiezometro)
      {
        ObjGrafico.AxisY.Max = this.CurrentModulo.MaxAdattamentoAsseYPress
        ObjGrafico.AxisY.Min = this.CurrentModulo.MinAdattamentoAsseYPress
        ObjGrafico.AxisY.Udm = this.CurrentModulo.UdmYPress               
      }
      else
      {
        ObjGrafico.AxisY.Min = this.CurrentModulo.MinAdattamentoAsseY
        ObjGrafico.AxisY.Max = this.CurrentModulo.MaxAdattamentoAsseY
        ObjGrafico.AxisY.Udm = this.CurrentModulo.UdmY
      }
      this.PopupImpostazioniAsseY = false
    },
    
    MixInsSetObjGraficoCampRil(OggettoGrafico, ModuloCorrente, IsGraficoVerticale = false)
    {
      if(IsGraficoVerticale)
      {
        this.MaxYCampioniRilevatiFiltrati(ModuloCorrente)
        
        if(ModuloCorrente.MinAdattamentoAsseY != undefined)
          ModuloCorrente.MinAdattamentoAsseY = Number(ModuloCorrente.MinAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MinAdattamentoAsseY))))
        if(ModuloCorrente.MaxAdattamentoAsseY != undefined)
          ModuloCorrente.MaxAdattamentoAsseY = Number(ModuloCorrente.MaxAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseY))))
        if(ModuloCorrente.UdmY != undefined)
          ModuloCorrente.UdmY                = Number(ModuloCorrente.UdmY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.UdmY))))
        
        if(this.IsEstensimetro)
        {
          if(ModuloCorrente.MaxAdattamentoAsseYDef != undefined)
            ModuloCorrente.MaxAdattamentoAsseYDef = Number(ModuloCorrente.MaxAdattamentoAsseYDef.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseYDef))))
          if(ModuloCorrente.MinAdattamentoAsseYDef != undefined)
            ModuloCorrente.MinAdattamentoAsseYDef = Number(ModuloCorrente.MinAdattamentoAsseYDef.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseYDef))))
          if(ModuloCorrente.UdmYDef != undefined)
            ModuloCorrente.UdmYDef = TZMathFunct.GetMultiplo(ModuloCorrente.UdmYDef, this.GetUdmToRound(ModuloCorrente.UdmYDef), 'PiuVicino')
        }

        else if(this.IsPiezometro)
        {
          if(ModuloCorrente.MaxAdattamentoAsseYPress != undefined)
            ModuloCorrente.MaxAdattamentoAsseYPress = Number(ModuloCorrente.MaxAdattamentoAsseYPress.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseYPress))))
          
          if(ModuloCorrente.MinAdattamentoAsseYPress != undefined)
            ModuloCorrente.MinAdattamentoAsseYPress = Number(ModuloCorrente.MinAdattamentoAsseYPress.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MinAdattamentoAsseYPress))))
          
          if(ModuloCorrente.UdmYPress != undefined)
            ModuloCorrente.UdmYPress                = Number(ModuloCorrente.UdmYPress.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.UdmYPress))))
        }
        
        OggettoGrafico.AxisY.Max = ModuloCorrente.MaxAdattamentoAsseY
        OggettoGrafico.AxisY.Min = ModuloCorrente.MinAdattamentoAsseY
        OggettoGrafico.AxisY.Udm = ModuloCorrente.UdmY

      }
      else
      {
        if(this.IsEstensimetro)
        {
          if(ModuloCorrente.MaxAdattamentoAsseYDef != undefined)
          {
            ModuloCorrente.MaxAdattamentoAsseYDef = Number(ModuloCorrente.MaxAdattamentoAsseYDef.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseYDef))))
            OggettoGrafico.AxisY.Max = ModuloCorrente.MaxAdattamentoAsseYDef
          }

          if(ModuloCorrente.MinAdattamentoAsseYDef != undefined)
          {
            ModuloCorrente.MinAdattamentoAsseYDef = Number(ModuloCorrente.MinAdattamentoAsseYDef.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseYDef))))
            OggettoGrafico.AxisY.Min = ModuloCorrente.MinAdattamentoAsseYDef
          }
          
          if(ModuloCorrente.UdmYDef != undefined)
          {
            ModuloCorrente.UdmYDef = TZMathFunct.GetMultiplo(ModuloCorrente.UdmYDef, this.GetUdmToRound(ModuloCorrente.UdmYDef), 'PiuVicino')          
            OggettoGrafico.AxisY.Udm = ModuloCorrente.UdmYDef 
          }
            
        }
        else if(this.IsPiezometro)
        {
          if(ModuloCorrente.MaxAdattamentoAsseYPress != undefined)
          {
            ModuloCorrente.MaxAdattamentoAsseYPress = Number(ModuloCorrente.MaxAdattamentoAsseYPress.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseYPress))))
            OggettoGrafico.AxisY.Max = ModuloCorrente.MaxAdattamentoAsseYPress
          }
          if(ModuloCorrente.MinAdattamentoAsseYPress != undefined)
          {
            ModuloCorrente.MinAdattamentoAsseYPress = Number(ModuloCorrente.MinAdattamentoAsseYPress.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MinAdattamentoAsseYPress))))
            OggettoGrafico.AxisY.Min = ModuloCorrente.MinAdattamentoAsseYPress
          }
          if(ModuloCorrente.UdmYPress != undefined)
          {
            ModuloCorrente.UdmYPress = Number(ModuloCorrente.UdmYPress.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.UdmYPress))))
            OggettoGrafico.AxisY.Udm = ModuloCorrente.UdmYPress 
          }
        }
        else
        {
          if(ModuloCorrente.MinAdattamentoAsseY != undefined)
          {
            ModuloCorrente.MinAdattamentoAsseY = Number(ModuloCorrente.MinAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MinAdattamentoAsseY))))
            OggettoGrafico.AxisY.Max = ModuloCorrente.MaxAdattamentoAsseY
          }

          if(ModuloCorrente.MaxAdattamentoAsseY != undefined)
          {
            ModuloCorrente.MaxAdattamentoAsseY = Number(ModuloCorrente.MaxAdattamentoAsseY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.MaxAdattamentoAsseY))))
            OggettoGrafico.AxisY.Min = ModuloCorrente.MinAdattamentoAsseY
          }

          if(ModuloCorrente.UdmY != undefined)
          {
            ModuloCorrente.UdmY                = Number(ModuloCorrente.UdmY.toFixed(SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(ModuloCorrente.UdmY))))
            OggettoGrafico.AxisY.Udm = ModuloCorrente.UdmY
          }
        }
      }
  
      let AxisX                         = {}
      AxisX.TipoUdmX                    = TIPI_UDM_X.Giorni
      AxisX.UdmX                        = 1
      AxisX.Modificato                  = false
      OggettoGrafico.AxisX             = AxisX
  
      OggettoGrafico.ListaRighelli     = []
      OggettoGrafico.TipoUdmX          = 0
      OggettoGrafico.UdmX              = 1
    },

    GetUdmToRound(Notch)
    {
      if(Notch < 2) 
        return 0.1
      if(Notch < 20) 
        return 1
      if(Notch < 40) 
        return 2
      if(Notch < 100) 
        return 5
      else return 10
    },

    MixInsDownloadDatiAcquisitiModuli(Catena, AlCompletamento = () => {}, IsCaricaGraficiGV = false)
    {
      Catena.Sensori.forEach((Sensore)=>
      {
        Sensore.Dati = []
      })
      Catena.DatiMeteo = null

      if(!this.InDownloadDatiAcquisiti)
      {
        this.InDownloadDatiAcquisiti      = true
        this.OggettoModalCaricamentoDati  = new TOggettoModalCaricamentoDati()
        var Self                          = this
        var i                             = 0
        this.ListaSuperamentiSoglia       = []
        this.IndexCalcolatiSpostamenti    = 0
        
        this.CalcoloBarraDiProgressione(0)
        this.CaricamentoDatiModuli        = true;

        var HandleSingolaChiamata = function(PorzioneDate, OnSuccess)
        {
          Self.CaricaDatiCatenaStorici(Catena,
                                       PorzioneDate.DallaData,
                                       PorzioneDate.AllaData,
                                       IsCaricaGraficiGV,
                                       function()
                                       {
                                         OnSuccess()  
                                       }, 
                                       function()
                                       {
                                         alert(Self.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_ERR_DOWNLOAD',Self.LinguaUtente))
                                         Self.CaricamentoDatiModuli = false;
                                       })                
        }

        var DownloadDatiAcquisitiOgniTotGiorni = function(VettorePorzioniDiDate, OnEndImporting)
        {
          if(!Self.OperazioneAnnullata)
          {
            if(i < VettorePorzioniDiDate.length)
            {
              HandleSingolaChiamata(VettorePorzioniDiDate[i], function()
                                                              {
                                                                i++; 
                                                                Self.CalcoloBarraDiProgressione(VettorePorzioniDiDate.length, i)
                                                                DownloadDatiAcquisitiOgniTotGiorni(VettorePorzioniDiDate, OnEndImporting)
                                                              });
            }
            else OnEndImporting();
          }
          else OnEndImporting();
        }

        setTimeout(function()
        {
          DownloadDatiAcquisitiOgniTotGiorni(Self.VettorePorzioniDiDate, 
                                            function() 
                                            { 
                                              Self.CalcoloBarraDiProgressione(Self.VettorePorzioniDiDate.length, i)
                                              setTimeout(function()
                                              {
                                                if(!IsCaricaGraficiGV)
                                                {
                                                  if(Self.TipoGrafico != TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SOVR &&
                                                     Self.TipoGrafico != TIPOLOGIA_GRAFICI_STORICI.ASSORBIMENTO &&
                                                     Self.TipoGrafico != TIPOLOGIA_GRAFICI_STORICI.TENSIONE_ALIMENTAZIONE)
                                                    Self.GestioneDeiDatiAcquisitiDaDatabase(Catena)
                                                  else 
                                                  {
                                                    Self.ModuliMostrati = Catena.Sensori
                                                  }
                                                }
                                                else 
                                                {
                                                  Self.ModuliMostrati = Catena.Sensori
                                                  Self.ModuliMostrati.forEach(Element => Element.Disegna = true)
                                                }

                                                Self.OperazioneAnnullata   = false

                                                // if(Self.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SEPARATI)
                                                //   Self.GestioneTotaliSpostamento()

                                                Self.CalcoloMassimoNumeroAsseY(Catena)

                                                Self.OrdinamentoDatiPerData(Catena, IsCaricaGraficiGV)

                                                if(Self.TipoGrafico != TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SEPARATI)
                                                {
                                                  Self.GestioneFiltroAllineamentoIncl(Catena)
                                                  Self.GestioneFiltroAllineamentoDef(Catena)
                                                  Self.GestioneFiltroAllineamentoTemp(Catena)
                                                }

                                                if(Self.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SEPARATI)
                                                  Self.GestioneUltimoTotaleSpostamento(Catena)

                                                Self.InDownloadDatiAcquisiti         = false
                                                Self.GraficiChange++
                                                Self.CaricamentoDatiModuli           = false                                                
                                                
                                                if(Catena.DatiMeteo != null && Catena.DatiMeteo.Dati.length > 0)
                                                {
                                                  Self.GetCumulativoPioggia(i)
                                                }

                                                if(Self.Falde)
                                                  Self.OrdinamentoSistemazioneFalde()

                                                if(!IsCaricaGraficiGV)
                                                  Self.OnWindowScroll()

                                                AlCompletamento()

                                              }, 500)
                                            })
        }, 1000);
      }
    },  

    CaricaDatiCatenaStorici(Catena, DallaData, AllaData, IsCaricaGraficiGV, OnSuccess, OnError)
    {
      let Self = this

      this.CaricamentoDatiModuli = true

      let ParametriQuery         = {}
      ParametriQuery.Moduli      = []
      this.ObjDati.ListaModuli.forEach((element) => {ParametriQuery.Moduli.push(element.Id)}) //this.ModuliConsiderati
      ParametriQuery.IdCatena    = this.ObjDati.IdCatena
      ParametriQuery.IdSito      = this.ObjDati.IdSito
      ParametriQuery.Dal         = TZDateFunct.DateInHTMLInputFormat(new Date(DallaData)) + ' ' + TZDateFunct.FormatDateTime('hh:nn', new Date(DallaData))
      ParametriQuery.Al          = TZDateFunct.DateInHTMLInputFormat(new Date(AllaData)) + ' ' + TZDateFunct.FormatDateTime('hh:nn', new Date(AllaData))
      ParametriQuery.TipoGrafico = this.ObjDati.TipoGrafico 
      ParametriQuery.Stacking    = this.Stacking
      // let DifferenzaDate = new Date(ParametriQuery.Al).valueOf() - new Date(ParametriQuery.Dal).valueOf()
      // this.ObjDati.VisualizzaMarkup = (DifferenzaDate <= 7 * 24 * 3600 * 1000) && this.ObjDati.VisualizzaMarkup
      
      if(this.ObjDati.ListaFalde.length != 0)
      {
        ParametriQuery.ListaFalde = []
        this.ObjDati.ListaFalde.forEach((element) => { ParametriQuery.ListaFalde.push(element.Id) })
      }

      if(this.ObjDati.ListaTuttiModuli.length != 0)
      {
        ParametriQuery.ListaTuttiModuli = []
        this.ObjDati.ListaTuttiModuli.forEach((element) => { ParametriQuery.ListaTuttiModuli.push(element.Id) })
      }

      SystemInformation.AdvQuery.ExecuteExternalScript('ExtraDatiCateneStorici', ParametriQuery, function(Answer) 
      {       
        if(Answer.ListaFalde.length != 0)
          Self.GestioneListaFalde(Answer.ListaFalde[0])
        else
          Self.Falde = {Sensori : []} 

        if(Answer.DatiMeteo != null)
        {
          if(Answer.DatiMeteo.length != 0)
            Self.GestioneDatiMeteo(Catena, Answer.DatiMeteo)
          else 
          {
            if(Catena.DatiMeteo == null)
            {
              Catena.DatiMeteo                 = {}
              Catena.DatiMeteo.Dati            = []
              Catena.DatiMeteo.PresenzaVento   = Self.ObjDati.VisualizzaAnemometro
              Catena.DatiMeteo.PresenzaPioggia = Self.ObjDati.VisualizzaPluviometro
              Catena.DatiMeteo.PresenzaTemp    = Self.ObjDati.VisualizzaTermometro
            }
          }
        }
        else 
        {
          if(Catena.DatiMeteo == null)
          {
            Catena.DatiMeteo                 = {}
            Catena.DatiMeteo.Dati            = []
            Catena.DatiMeteo.PresenzaVento   = Self.ObjDati.VisualizzaAnemometro
            Catena.DatiMeteo.PresenzaPioggia = Self.ObjDati.VisualizzaPluviometro
            Catena.DatiMeteo.PresenzaTemp    = Self.ObjDati.VisualizzaTermometro
          }
        }

        if(Answer.ListaTempSuolo != null)
          if(Answer.ListaTempSuolo[0].Sensori.length != 0)
            Self.GestioneListaTempSuolo(Catena, Answer.ListaTempSuolo[0])

        if (Self.TipoGrafico != TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_SUP_SOGLIE &&
            Self.TipoGrafico != TIPOLOGIA_GRAFICI_STORICI.EV_ACCELEROMETRICI_CRONOLOGIA)
        {
          if(Catena != null)
          {
            if(Answer.QueryData[0].Sensori.length != 0)
            {
              for(let i = 0; i < Answer.QueryData[0].Sensori.length; i++)
              {
                let Trovato = false
                for(let j = 0; j < Catena.Sensori.length; j++)
                {
                  if(Catena.Sensori[j].Id == Answer.QueryData[0].Sensori[i].Id)
                  {
                    Trovato = true
                    Catena.Sensori[j].Disegna = false

                    if(Catena.Sensori[j].Dati.length != 0)
                      Catena.Sensori[j].Dati = Catena.Sensori[j].Dati.concat(Answer.QueryData[0].Sensori[i].Dati)
                    else 
                    {
                      if(Catena.Sensori[j].Colore)
                      {
                        let Color = Catena.Sensori[j].Colore

                        Catena.Sensori[j]        = Answer.QueryData[0].Sensori[i]
                        Catena.Sensori[j].Colore = Color
                      }
                      else Catena.Sensori[j] = Answer.QueryData[0].Sensori[i]
                    }
                  }
                }

                if(!Trovato)
                  Catena.Sensori.push(Answer.QueryData[0].Sensori[i])
              }
            }
          }
          else Catena = Answer.QueryData[0]
        }
        else
        {
          for(let i = 0; i < Answer.QueryData[0].Sensori.length; i++)
          {
            Answer.QueryData[0].Sensori[i].Evidenziato = false
            Self.ListaSuperamentiSoglia.push(Answer.QueryData[0].Sensori[i])            
          }
        }

        if(IsCaricaGraficiGV)
        {
          for(let i = 0; i < Answer.QueryData[0].Sensori.length; i++)
          {
            Answer.QueryData[0].Sensori[i].Evidenziato = false
            Self.ListaSuperamentiSoglia.push(Answer.QueryData[0].Sensori[i])
          }
        }

        if(Self.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SEPARATI ||
            Self.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SOVR ||
            Self.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_ORARIA ||
            Self.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_GIORNALIERA ||
            Self.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_ORARIA ||
            Self.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_GIORNALIERA ||
            Self.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.STAZIONE_METEO ||
            Self.TipoGrafico == TIPOLOGIA_GRAFICI_STORICI.GRAFICI_GV)
        {
          Self.CalcoloSpostamenti(Catena)

          switch (Self.TipoGrafico)
          {
            case TIPOLOGIA_GRAFICI_STORICI.GRAFICI_GV                      : {
                                                                               Self.GestioneTotaliSpostamento(Self.ObjTotaleSpostamento, Answer.DatiPerTotaleSpost, Self.VettoreStartValueSpost)
                                                                               Self.GestioneTotaliVelocitaOraria(Self.ObjTotaleVelocitaH, Answer.QueryData[0].Sensori, Self.VettoreStartValueVelH)
                                                                               Self.GestioneTotaliVelocitaGiornaliera(Self.ObjTotaleVelocitaGG, Answer.QueryData[0].Sensori, Self.VettoreStartValueVelGG) 
                                                                               Self.GestioneTotaliAccelerazioneOraria(Self.ObjTotaleAccelerazioneH, Answer.QueryData[0].Sensori, Self.VettoreStartValueAccH)
                                                                               Self.GestioneTotaliAccelerazioneGiornaliera(Self.ObjTotaleAccelerazioneGG, Answer.QueryData[0].Sensori, Self.VettoreStartValueAccGG)
                                                                               break
                                                                             }
            case TIPOLOGIA_GRAFICI_STORICI.SPOSTAMENTI_GRAFICI_SEPARATI    : Self.GestioneTotaliSpostamento(Catena.OggettoTotaleSpostamento, Answer.DatiPerTotaleSpost, Self.VettoreStartValue, Catena); break
            case TIPOLOGIA_GRAFICI_STORICI.STAZIONE_METEO                  : Self.GestioneTotaliSpostamentoMeteo(Catena, Answer.DatiPerTotaleSpost); break
            case TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_ORARIA           : Self.GestioneTotaliVelocitaOraria(Catena.OggettoTotaleSpostamento, Answer.QueryData[0].Sensori, Self.VettoreStartValue, Catena); break
            case TIPOLOGIA_GRAFICI_STORICI.VELOCITA_MEDIA_GIORNALIERA      : Self.GestioneTotaliVelocitaGiornaliera(Catena.OggettoTotaleSpostamento, Answer.QueryData[0].Sensori, Self.VettoreStartValue, Catena); break 
            case TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_ORARIA      : Self.GestioneTotaliAccelerazioneOraria(Catena.OggettoTotaleSpostamento, Answer.QueryData[0].Sensori, Self.VettoreStartValue, Catena); break
            case TIPOLOGIA_GRAFICI_STORICI.ACCELERAZIONE_MEDIA_GIORNALIERA : Self.GestioneTotaliAccelerazioneGiornaliera(Catena.OggettoTotaleSpostamento, Answer.QueryData[0].Sensori, Self.VettoreStartValue, Catena); break
          }
        }

        OnSuccess()
      },
      function(ErrorMessage,DescrErrore)
      {
        OnError()
        alert(ErrorMessage + '[' + DescrErrore + ']')
      }) 
    },

    GetDatiModuliCorretti(DatiPerTotale, ModuloTotaliDiRiferimento)
    {
      let Result = []

      for(let i = 0; i < DatiPerTotale.length; i++)
      {
        for(let j = 0; j < ModuloTotaliDiRiferimento.length; j++)
        {
          if(DatiPerTotale[i].Id == ModuloTotaliDiRiferimento[j].Id)
          {
            Result.push(DatiPerTotale[i])
          }
        }
      }
      return Result
    },

    GestioneTotaliVelocitaOraria(ObjTotale, DatiTotale, VettoreStartValue, Catena = null)
    {      
      if(DatiTotale != null)
      {
        let DatiPerTotaleVelocita = JSON.parse(JSON.stringify(DatiTotale))
        
        if(this.ModuliConsideratiTotaleVelH !== undefined && this.ModuliConsideratiTotaleVelH !== null)
          DatiPerTotaleVelocita = this.GetDatiModuliCorretti(DatiPerTotaleVelocita, this.ModuliConsideratiTotaleVelH)

        if(ObjTotale == null)
        {
          ObjTotale = {}
          ObjTotale.ListaTotaliSpostamento = []
        }

        for(let i = 0; i < DatiPerTotaleVelocita.length; i++)
        {
          let LsDati = DatiPerTotaleVelocita[i]
          for(let j = 0; j < LsDati.Dati.length; j++)
          {
            let Dato = LsDati.Dati[j]
            if(Dato.Velocita != null && Dato.Velocita != undefined && Dato.Pitch != null && Dato.Roll != null)
            { 
              let Trovato = false
              // let Indice = 0
              if(VettoreStartValue[Dato.Id] == undefined)
                 VettoreStartValue[Dato.Id] = Dato.Velocita

              for(let k = 0; k < ObjTotale.ListaTotaliSpostamento.length; k++)
              {
                let DataElaborata = ObjTotale.ListaTotaliSpostamento[k].Data.slice(0, 13) + ':00' 
                if(DataElaborata <= Dato.Data.slice(0, 13) + ':00')
                {
                  Trovato = true
                  if (DataElaborata == Dato.Data.slice(0, 13) + ':00')
                    ObjTotale.ListaTotaliSpostamento[k].SpostamentoTotale += Dato.Velocita - VettoreStartValue[Dato.Id]
                  else
                    ObjTotale.ListaTotaliSpostamento.splice(k, 0, {Data : Dato.Data.slice(0, 13) + ':00', SpostamentoTotale : (Dato.Velocita - VettoreStartValue[Dato.Id])})
                  break
                }
              }
              if (!Trovato)
                ObjTotale.ListaTotaliSpostamento.push({Data : Dato.Data.slice(0, 13) + ':00', SpostamentoTotale : (Dato.Velocita - VettoreStartValue[Dato.Id])})


              // if (!Trovato)
                // ObjTotale.ListaTotaliSpostamento.push({ Data : Dato.Data.slice(0, 13) + ':00', SpostamentoTotale : (Dato.Velocita - VettoreStartValue[Dato.Id]) })
              // else ObjTotale.ListaTotaliSpostamento[Indice].SpostamentoTotale += Dato.Velocita - VettoreStartValue[Dato.Id]
            }
          }
        }

        if(Catena != null)
          Catena.OggettoTotaleSpostamento = ObjTotale
        else this.ObjTotaleVelocitaH = ObjTotale
      }
    },

    GestioneTotaliVelocitaGiornaliera(ObjTotale, DatiTotale, VettoreStartValue, Catena = null)
    {
      if(DatiTotale != null)
      {
        let DatiPerTotaleVelocita = JSON.parse(JSON.stringify(DatiTotale))

        if(this.ModuliConsideratiTotaleVelGG !== undefined && this.ModuliConsideratiTotaleVelGG !== null)
          DatiPerTotaleVelocita = this.GetDatiModuliCorretti(DatiPerTotaleVelocita, this.ModuliConsideratiTotaleVelGG)

        // let FMsDay = 24 * 60 * 60 * 1000

        if(ObjTotale == null)
        {
          ObjTotale = {}
          ObjTotale.ListaTotaliSpostamento = []
        }

        for(let i = 0; i < DatiPerTotaleVelocita.length; i++)
        {
          let LsDati = DatiPerTotaleVelocita[i]
          for(let j = 0; j < LsDati.Dati.length; j++)
          {
            let Dato = LsDati.Dati[j]
            if(Dato.Velocita != null && Dato.Velocita != undefined && Dato.Pitch != null && Dato.Roll != null)
            { 
              let Trovato = false
              let Indice = 0
              // let DateTimeStamp = new Date(Dato.Data.replace(" ", "T"))
              // let DateTimeStampNumber = DateTimeStamp.getTime()
              // let DataDaPlottare = parseInt(DateTimeStampNumber / FMsDay, 10) * FMsDay + FMsDay / 2

              let DataDaPlottare = (Dato.Data).substr(0,10)

              if(VettoreStartValue[Dato.Id] == undefined)
                 VettoreStartValue[Dato.Id] = Dato.Velocita

              for(let k = 0; k < ObjTotale.ListaTotaliSpostamento.length; k++)
              {
                // let DataDaConfrontare = parseInt(ObjTotale.ListaTotaliSpostamento[k].Data / FMsDay, 10) * FMsDay + FMsDay / 2
                const DataDaConfrontare = TZDateFunct.FormatDateTime('yyyy-mm-dd', new Date(ObjTotale.ListaTotaliSpostamento[k].Data))

                if(DataDaConfrontare == DataDaPlottare)
                {
                  Trovato = true
                  Indice = k
                  break
                }
              }
              if(!Trovato)
                ObjTotale.ListaTotaliSpostamento.push({ 
                                                        Data : Date.parse(DataDaPlottare + ' 12:00'), 
                                                        // Data : DataDaPlottare, 
                                                        SpostamentoTotale : (Dato.Velocita - VettoreStartValue[Dato.Id]) 
                                                      })
              else ObjTotale.ListaTotaliSpostamento[Indice].SpostamentoTotale += Dato.Velocita - VettoreStartValue[Dato.Id]
            }
          }
        }

        for(let i = 0; i < ObjTotale.ListaTotaliSpostamento.length; i++)
        {
          let VelocitaGiornalieraData = new Date(ObjTotale.ListaTotaliSpostamento[i].Data)
          let VelocitaGiornalieraAnno = VelocitaGiornalieraData.getFullYear()
          let VelocitaGiornalieraMese = String(VelocitaGiornalieraData.getMonth() + 1).padStart(2, '0')
          let VelocitaGiornalieraGiorno = String(VelocitaGiornalieraData.getDate()).padStart(2, '0')
          let VelocitaGiornalieraOre = String(VelocitaGiornalieraData.getHours()).padStart(2, '0')
          let VelocitaGiornalieraMinuti = String(VelocitaGiornalieraData.getMinutes()).padStart(2, '0')
          let VelocitaGiornalieradataStringa = `${VelocitaGiornalieraAnno}-${VelocitaGiornalieraMese}-${VelocitaGiornalieraGiorno} ${VelocitaGiornalieraOre}:${VelocitaGiornalieraMinuti}`
          ObjTotale.ListaTotaliSpostamento[i].Data = VelocitaGiornalieradataStringa
        }

        if(Catena != null)
          Catena.OggettoTotaleSpostamento = ObjTotale
        else this.ObjTotaleVelocitaGG = ObjTotale
      }
    },

    GestioneTotaliAccelerazioneGiornaliera(ObjTotale, DatiTotale, VettoreStartValue, Catena = null)
    {
      if(DatiTotale != null)
      {
        let DatiPerTotaleAccelerazione = JSON.parse(JSON.stringify(DatiTotale))
        
        if(this.ModuliConsideratiTotaleAccGG !== undefined && this.ModuliConsideratiTotaleAccGG !== null)
          DatiPerTotaleAccelerazione = this.GetDatiModuliCorretti(DatiPerTotaleAccelerazione, this.ModuliConsideratiTotaleAccGG)
  
        // let FMsDay = 24 * 60 * 60 * 1000

        if(ObjTotale == null)
        {
          ObjTotale = {}
          ObjTotale.ListaTotaliSpostamento = []
        }

        for(let i = 0; i < DatiPerTotaleAccelerazione.length; i++)
        {
          let LsDati = DatiPerTotaleAccelerazione[i]
          for(let j = 0; j < LsDati.Dati.length; j++)
          {
            let Dato = LsDati.Dati[j]
            if(Dato.Accelerazione != null && Dato.Accelerazione != undefined && Dato.Pitch != null && Dato.Roll != null)
            { 
              let Trovato = false
              let Indice = 0
              // let DateTimeStamp = new Date(Dato.Data.replace(" ", "T"))
              // let DateTimeStampNumber = DateTimeStamp.getTime()
              // let DataDaPlottare = parseInt(DateTimeStampNumber / FMsDay, 10) * FMsDay + FMsDay / 2

              let DataDaPlottare = (Dato.Data).substr(0,10)

              if(VettoreStartValue[Dato.Id] == undefined)
                 VettoreStartValue[Dato.Id] = Dato.Accelerazione

              for(let k = 0; k < ObjTotale.ListaTotaliSpostamento.length; k++)
              {
                // let DataDaConfrontare = parseInt(ObjTotale.ListaTotaliSpostamento[k].Data / FMsDay, 10) * FMsDay + FMsDay / 2
                const DataDaConfrontare = TZDateFunct.FormatDateTime('yyyy-mm-dd', new Date(ObjTotale.ListaTotaliSpostamento[k].Data))

                if(DataDaConfrontare == DataDaPlottare)
                {
                  Trovato = true
                  Indice = k
                  break
                }
              }
              if(!Trovato)
                ObjTotale.ListaTotaliSpostamento.push({ 
                                                        Data : Date.parse(DataDaPlottare + ' 12:00'), 
                                                        // Data : DataDaPlottare,
                                                        SpostamentoTotale : (Dato.Accelerazione - VettoreStartValue[Dato.Id]) 
                                                      })
              else ObjTotale.ListaTotaliSpostamento[Indice].SpostamentoTotale += Dato.Accelerazione - VettoreStartValue[Dato.Id]
            }
          }
        }
        
        for(let i = 0; i < ObjTotale.ListaTotaliSpostamento.length; i++)
        {
          let AccelerazioneGiornalieraData = new Date(ObjTotale.ListaTotaliSpostamento[i].Data)
          let AccelerazioneGiornalieraAnno = AccelerazioneGiornalieraData.getFullYear()
          let AccelerazioneGiornalieraMese = String(AccelerazioneGiornalieraData.getMonth() + 1).padStart(2, '0')
          let AccelerazioneGiornalieraGiorno = String(AccelerazioneGiornalieraData.getDate()).padStart(2, '0')
          let AccelerazioneGiornalieraOre = String(AccelerazioneGiornalieraData.getHours()).padStart(2, '0')
          let AccelerazioneGiornalieraMinuti = String(AccelerazioneGiornalieraData.getMinutes()).padStart(2, '0')
          let AccelerazioneGiornalieradataStringa = `${AccelerazioneGiornalieraAnno}-${AccelerazioneGiornalieraMese}-${AccelerazioneGiornalieraGiorno} ${AccelerazioneGiornalieraOre}:${AccelerazioneGiornalieraMinuti}`
          ObjTotale.ListaTotaliSpostamento[i].Data = AccelerazioneGiornalieradataStringa
        }

        if(Catena != null)
          Catena.OggettoTotaleSpostamento = ObjTotale
        else this.ObjTotaleAccelerazioneGG = ObjTotale
      }
    },

    GestioneTotaliAccelerazioneOraria(ObjTotale, DatiTotale, VettoreStartValue, Catena = null)
    {

      if(DatiTotale != null)
      {
        let DatiPerTotaleAccelerazione = JSON.parse(JSON.stringify(DatiTotale))

        if(this.ModuliConsideratiTotaleAccH !== undefined && this.ModuliConsideratiTotaleAccH !== null)
          DatiPerTotaleAccelerazione = this.GetDatiModuliCorretti(DatiPerTotaleAccelerazione, this.ModuliConsideratiTotaleAccH)
        
        if(ObjTotale == null)
        {
          ObjTotale = {}
          ObjTotale.ListaTotaliSpostamento = []
        }

        for(let i = 0; i < DatiPerTotaleAccelerazione.length; i++)
        {
          let LsDati = DatiPerTotaleAccelerazione[i]
          for(let j = 0; j < LsDati.Dati.length; j++)
          {
            let Dato = LsDati.Dati[j]
            if(Dato.Accelerazione != null && Dato.Accelerazione != undefined && Dato.Pitch != null && Dato.Roll != null)
            { 
              let Trovato = false
              // let Indice = 0
              if(VettoreStartValue[Dato.Id] == undefined)
                 VettoreStartValue[Dato.Id] = Dato.Accelerazione

              // for(let k = 0; k < ObjTotale.ListaTotaliSpostamento.length; k++)
              // {
              //   if(ObjTotale.ListaTotaliSpostamento[k].Data == Dato.Data)
              //   {
              //     Trovato = true
              //     Indice = k
              //     break
              //   }
              // }
              // if(!Trovato)
              //   ObjTotale.ListaTotaliSpostamento.push({ Data : Dato.Data, SpostamentoTotale : (Dato.Accelerazione - VettoreStartValue[Dato.Id]) })
              // else ObjTotale.ListaTotaliSpostamento[Indice].SpostamentoTotale += Dato.Accelerazione - VettoreStartValue[Dato.Id]

              for(let k = 0; k < ObjTotale.ListaTotaliSpostamento.length; k++)
              {
                let DataElaborata = ObjTotale.ListaTotaliSpostamento[k].Data.slice(0, 13) + ':00' 
                if(DataElaborata <= Dato.Data.slice(0, 13) + ':00')
                {
                  Trovato = true
                  if (DataElaborata == Dato.Data.slice(0, 13) + ':00')
                    ObjTotale.ListaTotaliSpostamento[k].SpostamentoTotale += Dato.Accelerazione - VettoreStartValue[Dato.Id]
                  else
                    ObjTotale.ListaTotaliSpostamento.splice(k, 0, {Data : Dato.Data.slice(0, 13) + ':00', SpostamentoTotale : (Dato.Accelerazione - VettoreStartValue[Dato.Id])})
                  break
                }
              }
              if (!Trovato)
                ObjTotale.ListaTotaliSpostamento.push({Data : Dato.Data.slice(0, 13) + ':00', SpostamentoTotale : (Dato.Accelerazione - VettoreStartValue[Dato.Id])})
            }
          }
        }
        if(Catena != null)
          Catena.OggettoTotaleSpostamento = ObjTotale
        else this.ObjTotaleAccelerazioneH = ObjTotale
      }
    },

    GestioneTotaliSpostamentoMeteo(Catena, DatiPerTotaleSpost)
    {
      if(DatiPerTotaleSpost != null)
      {
        if(Catena.OggettoTotaleSpostamento == null)
        {
          Catena.OggettoTotaleSpostamento = {}
          Catena.OggettoTotaleSpostamento.ListaTotaliSpostamento = []
        }

        for(let i = 0; i < DatiPerTotaleSpost.length; i++)
        {
          let Dato = DatiPerTotaleSpost[i]

          if(Dato.Roll != null && Dato.Pitch != null)
          { 
            let SpostamentoAssePendenza   = this.GetSpostamentoAssePendenza(Dato, this.ObjDati.OrientamentoAsse, Dato.Lunghezza, Dato.Orientamento);
            SpostamentoAssePendenza       = SpostamentoAssePendenza * 1000
            
            if (this.VettoreStartValue[Dato.Id] == undefined)
              this.VettoreStartValue[Dato.Id] = SpostamentoAssePendenza

            this.SommaSpostamenti += SpostamentoAssePendenza - this.VettoreStartValue[Dato.Id]
            
            if (this.LastData != Dato.Data)
            {
              Catena.OggettoTotaleSpostamento.ListaTotaliSpostamento.push({ Data : Dato.Data, SpostamentoTotale : this.SommaSpostamenti })
              this.SommaSpostamenti = 0;
              this.LastData         = Dato.Data
            }
          }
        }
      }
    },

    GestioneTotaliSpostamento(ObjTotale, DatiTotale, VettoreStartValue, Catena = null)
    {
      //DA finire
      this.LastData = ""
      this.SommaSpostamenti = 0
      if(DatiTotale != null)
      {
        let DatiPerTotaleSpost = JSON.parse(JSON.stringify(DatiTotale))

        if(this.ModuliConsideratiTotaleSpost !== undefined && this.ModuliConsideratiTotaleSpost !== null)
          DatiPerTotaleSpost = this.GetDatiModuliCorretti(DatiPerTotaleSpost, this.ModuliConsideratiTotaleSpost)

        if(ObjTotale == null)
        {
          ObjTotale = {}
          ObjTotale.ListaTotaliSpostamento = []
        }

        for(let i = 0; i < DatiPerTotaleSpost.length; i++)
        {
          let Dato = DatiPerTotaleSpost[i]

          if(Dato.Roll != null && Dato.Pitch != null)
          { 
            let SpostamentoAssePendenza   = this.GetSpostamentoAssePendenza(Dato, this.ObjDati.OrientamentoAsse, Dato.Lunghezza, Dato.Orientamento);
            SpostamentoAssePendenza       = SpostamentoAssePendenza * 1000
            
            if (VettoreStartValue[Dato.Id] == undefined)
              VettoreStartValue[Dato.Id] = SpostamentoAssePendenza

            if (this.LastData != Dato.Data)
            {
              if(this.LastData != "")
              ObjTotale.ListaTotaliSpostamento.push({ Data : this.LastData, SpostamentoTotale : this.SommaSpostamenti })
              this.SommaSpostamenti = 0;
              this.LastData         = Dato.Data
            }

            this.SommaSpostamenti += SpostamentoAssePendenza - VettoreStartValue[Dato.Id]
          }
        }
        if(Catena != null)
          Catena.OggettoTotaleSpostamento = ObjTotale
        else this.ObjTotaleSpostamento = ObjTotale
      }
    },

    GetSpostamentoRoll(Lunghezza, CampioneSensore)
    {
      return Lunghezza * Math.sin(TZMathFunct.DegToRad(CampioneSensore.Roll));
    },

    GetSpostamentoPitch(Lunghezza, CampioneSensore)
    {
      return Lunghezza * Math.sin(TZMathFunct.DegToRad(CampioneSensore.Pitch));
    },

    GetSpostamentoAssePendenza(CampioneSensore, OrientamentoAsse, Lunghezza, Orientamento)
    {
      return this.GetSpostamentoRoll(Lunghezza, CampioneSensore)  * Math.cos(TZMathFunct.DegToRad(Orientamento + OrientamentoAsse)) +
             this.GetSpostamentoPitch(Lunghezza, CampioneSensore) * Math.sin(TZMathFunct.DegToRad(Orientamento + OrientamentoAsse));
    },

    CalcoloSpostamenti(Catena)
    {
      var PrecDataIncl          = 0;
      // var PrecDataPiezo         = 0; piez
      var PrecVelocita          = 0;
      // var PrecPressione         = 0; piez
      // var PrecVelPressione      = 0; piez
      var PrecOffsetSpostamento = 0;
      var StartValue            = 0;

      var StartIndex            = 0

      for(let i = 0; i < Catena.Sensori.length; i++)
      {
        var Sensore = Catena.Sensori[i]
        StartIndex  = Sensore.LunghezzaDatiPrecedenti != undefined? Sensore.LunghezzaDatiPrecedenti : 0

        var CounterFromPrevInclValid    = 0;
        // var CounterFromPrevPiezoValid = 0;

        for(let j = StartIndex; j < Sensore.Dati.length; j++)
        {
          let CampioneSensore             = Sensore.Dati[j]

          if(CampioneSensore.Roll != null && CampioneSensore.Pitch != null)
          {
            let SpostamentoAssePendenza   = this.GetSpostamentoAssePendenza(CampioneSensore, this.ObjDati.OrientamentoAsse, Sensore.Lunghezza, Sensore.Orientamento);
            SpostamentoAssePendenza       = SpostamentoAssePendenza * 1000

            if(CounterFromPrevInclValid == 0)
            {
              if(Sensore.LunghezzaDatiPrecedenti != null)
              {
              //calcolo gli spostamenti per ogni chiamata, cerco il valore del'ultimo valote della scorsa chiamata
                CounterFromPrevInclValid = StartIndex
                StartValue               = this.GetSpostamentoAssePendenza(Sensore.Dati[0], this.ObjDati.OrientamentoAsse, Sensore.Lunghezza, Sensore.Orientamento);
                StartValue               = StartValue * 1000
                PrecDataIncl             = (new Date(Sensore.Dati[j - 1].Data)).getTime()
                PrecOffsetSpostamento    = this.GetSpostamentoAssePendenza(Sensore.Dati[j - 1], this.ObjDati.OrientamentoAsse, Sensore.Lunghezza, Sensore.Orientamento);
                PrecOffsetSpostamento    = PrecOffsetSpostamento * 1000
              }
              else
              {
                StartValue                    = SpostamentoAssePendenza
                CampioneSensore.Accelerazione = 0  
                CampioneSensore.Velocita      = 0  
              }
            }

            Sensore.LunghezzaDatiPrecedenti = Sensore.Dati.length

            var TimestampData             = (new Date(CampioneSensore.Data)).getTime()
            CampioneSensore.Spostamento = SpostamentoAssePendenza - StartValue
            // CampioneSensore.Spostamento = Math.round(SpostamentoAssePendenza * 10) / 10 - Math.round(StartValue * 10) / 10;
            // CampioneSensore.Spostamento = Math.round((SpostamentoAssePendenza - StartValue) * 10) / 10;

            
            if(CounterFromPrevInclValid > 0)
            {
              var OffsetSpostamento         = SpostamentoAssePendenza - PrecOffsetSpostamento;
              let UnitaDiTempo              = 60 * 60 * 1000
              let DeltaTime                 = Math.round(((TimestampData - PrecDataIncl) / UnitaDiTempo))
              if(DeltaTime == 0)
                DeltaTime = 1

              CampioneSensore.Velocita      = OffsetSpostamento / DeltaTime;
              CampioneSensore.Accelerazione = 0

              if(CounterFromPrevInclValid > 1)
              {
                CampioneSensore.Accelerazione = (CampioneSensore.Velocita - PrecVelocita) / DeltaTime;
              }
              PrecVelocita          = CampioneSensore.Velocita;
            }
            
            PrecDataIncl          = TimestampData;
            PrecOffsetSpostamento = SpostamentoAssePendenza
            CounterFromPrevInclValid++
          }
        } 
      }
//                    if CampioneSensore.PiezoValido then
//                       begin
//                         if CounterFromPrevPiezoValid > 0 then
//                            begin
//                             DeltaTime                    := (CampioneSensore.Data - PrecDataPiezo) * HOUR_X_DAY;
//                             VelAccellSensore.VelocitaProf := (CampioneSensore.Pressione - PrecPressione) / DeltaTime;
//                             VelAccellSensore.VelProfValida := True;
//                             if CounterFromPrevPiezoValid > 1 then
//                                begin
//                                  VelAccellSensore.AccellerProf := (VelAccellSensore.VelocitaProf - PrecVelPressione) / DeltaTime;
//                                  VelAccellSensore.AccProfValida := True;
//                                end;
//                             PrecVelPressione := VelAccellSensore.VelocitaProf;
//                            end;
//                         PrecPressione    := CampioneSensore.Pressione;
//                         PrecDataPiezo    := CampioneSensore.Data;
//                         Inc(CounterFromPrevPiezoValid);
//                       end;
// //                   else CounterFromPrevPiezoValid := 0;
      
    },

    
    GestioneListaTempSuolo(Catena, DatiTempSuolo)
    {
      if(Catena.ListaTempSuolo != null && Catena.ListaTempSuolo != undefined)
      {
        if(DatiTempSuolo.Sensori.length != 0)
        {
          for(let i = 0; i < DatiTempSuolo.Sensori.length; i++)
          {
            let Trovato = false
            for(let j = 0; j < Catena.ListaTempSuolo.Sensori.length; j++) 
            {
              if(Catena.ListaTempSuolo.Sensori[j].Id == DatiTempSuolo.Sensori[i].Id)
              {
                Trovato = true
                Catena.ListaTempSuolo.Sensori[j].Visualizza = false

                if(Catena.ListaTempSuolo.Sensori[j].Dati.length != 0)
                  Catena.ListaTempSuolo.Sensori[j].Dati = Catena.ListaTempSuolo.Sensori[j].Dati.concat(DatiTempSuolo.Sensori[i].Dati)
                else Catena.ListaTempSuolo.Sensori[j] = DatiTempSuolo.Sensori[i]
              }
            }
            if(!Trovato)
              Catena.ListaTempSuolo.Sensori.push(DatiTempSuolo.Sensori[i])
          }
        }
      }
      else
      {
        Catena.ListaTempSuolo = {}
        Catena.ListaTempSuolo = DatiTempSuolo
      }

      for(let j = 0; j < Catena.ListaTempSuolo.Sensori.length; j++) 
      {
        Catena.ListaTempSuolo.Sensori[j].Visualizza = false
      }
    },

    GestioneDatiMeteo(Catena, DatiMeteoDb)
    {
      if(Catena.DatiMeteo == null)
      {
        Catena.DatiMeteo                 = {}
        Catena.DatiMeteo.Dati            = []
        Catena.DatiMeteo.PresenzaVento   = false
        Catena.DatiMeteo.PresenzaPioggia = false
        Catena.DatiMeteo.PresenzaTemp    = false
      }
      
      Catena.DatiMeteo.PresenzaVento   = this.ObjDati.VisualizzaAnemometro
      Catena.DatiMeteo.PresenzaPioggia = this.ObjDati.VisualizzaPluviometro
      Catena.DatiMeteo.PresenzaTemp    = this.ObjDati.VisualizzaTermometro 

      for(let i = 0; i < DatiMeteoDb.length; i++)
        Catena.DatiMeteo.Dati.push(DatiMeteoDb[i])
    },

    GestioneListaFalde(ListaFaldeDb)
    {
      if(ListaFaldeDb != null)
      {
        if(this.Falde != null)
        {
          if(ListaFaldeDb.Sensori.length != 0)
          {
            for(let i = 0; i < ListaFaldeDb.Sensori.length; i++)
            {
              let Trovato = false
              for(let j = 0; j < this.Falde.Sensori.length; j++)
                if(this.Falde.Sensori[j].Id == ListaFaldeDb.Sensori[i].Id)
                {
                  Trovato = true
                  this.Falde.Sensori[j].Disegna = false

                  if(this.Falde.Sensori[j].Dati.length != 0)
                    this.Falde.Sensori[j].Dati = this.Falde.Sensori[j].Dati.concat(ListaFaldeDb.Sensori[i].Dati)
                  else 
                  {
                    if(this.Falde.Sensori[j].Colore)
                    {
                      let Color = this.Falde.Sensori[j].Colore

                      this.Falde.Sensori[j]        = ListaFaldeDb.Sensori[i]
                      this.Falde.Sensori[j].Colore = Color
                    }
                    else this.Falde.Sensori[j] = ListaFaldeDb.Sensori[i]
                  }
                }

              if(!Trovato)
                this.Falde.Sensori.push(ListaFaldeDb.Sensori[i])
            }
          }
        }
        else this.Falde = ListaFaldeDb
      }
    },

    OnWindowScroll()
    {
      let CurrentHeight = this.$refs.ContainerSensori.getBoundingClientRect().y - 115   
      if(this.ModuliMostrati)  
      {
        let SingleElementoHeight = this.$refs.ContainerSensori.offsetHeight / this.ModuliMostrati.length
        
        for (let i = 0; i < this.ModuliMostrati.length; i++)
        {
          if ((i * SingleElementoHeight > -CurrentHeight && i * SingleElementoHeight < -CurrentHeight + this.AltezzaPagina - 50) ||
              ((i + 1) * SingleElementoHeight > -CurrentHeight && (i + 1) * SingleElementoHeight < -CurrentHeight + this.AltezzaPagina - 50))
          {
            this.ModuliMostrati[i].Disegna = true
          } 
        }
      }     
    },  

    OrdinamentoSistemazioneFalde()
    {
      for(let i = 0; i < this.Falde.Sensori.length; i++)
      { 
        this.Falde.Sensori[i].Dati.sort(function(a,b)
        {
          if(a.Data < b.Data)
            return -1
          if(a.Data > b.Data)
            return 1
          return 0
        })
      }
      
      this.Falde.Sensori.forEach(function(Falda)
      {
        Falda.Selezionata = false
      })
    }, 

    GestioneUltimoTotaleSpostamento(Catena)
    {
      Catena.OggettoTotaleSpostamento.ListaTotaliSpostamento.push({ Data : this.LastData, SpostamentoTotale : this.SommaSpostamenti })
    },

    GestioneFiltroAllineamentoTemp(Catena)
    {
      if(this.ObjDati.AllineamentoTemp != null)
      {
        for(let i = 0; i < this.ObjDati.AllineamentoTemp.Dati.length; i++)
        {
          for(let j = 0; j < Catena.Sensori.length; j++)
          {
            if(this.ObjDati.AllineamentoTemp.Dati[i].MODULO == Catena.Sensori[j].Id)
            {
              for(let k = 0; k < Catena.Sensori[j].Dati.length; k++)
              {
                Catena.Sensori[j].Dati[k].Temperatura = Catena.Sensori[j].Dati[k].Temperatura - (this.ObjDati.AllineamentoIncl.Dati[i].TEMPERATURA / 10)
              }
            }
          }
        }
      }
    },

    GestioneFiltroAllineamentoDef(Catena)
    {
      if(this.ObjDati.AllineamentoDef != null)
      {
        for(let i = 0; i < this.ObjDati.AllineamentoDef.Dati.length; i++)
        {
          for(let j = 0; j < Catena.Sensori.length; j++)
          {
            if(this.ObjDati.AllineamentoDef.Dati[i].MODULO == Catena.Sensori[j].Id)
            {
              for(let k = 0; k < Catena.Sensori[j].Dati.length; k++)
              {
                Catena.Sensori[j].Dati[k].Deformazione = Catena.Sensori[j].Dati[k].Deformazione - (this.ObjDati.AllineamentoIncl.Dati[i].DEFORMAZIONE / 1000)
              }
            }
          }
        }
      }
    },

    GestioneFiltroAllineamentoIncl(Catena)
    {
      if(this.ObjDati.AllineamentoIncl != null)
      {
        for(let i = 0; i < this.ObjDati.AllineamentoIncl.Dati.length; i++)
        {
          for(let j = 0; j < Catena.Sensori.length; j++)
          {
            if(this.ObjDati.AllineamentoIncl.Dati[i].MODULO == Catena.Sensori[j].Id)
            {
              // Catena.Sensori[j].AllineamentoIncl = this.ObjDati.AllineamentoIncl.Dati[i]
              for(let k = 0; k < Catena.Sensori[j].Dati.length; k++)
              {
                Catena.Sensori[j].Dati[k].Pitch = Catena.Sensori[j].Dati[k].Pitch - (this.ObjDati.AllineamentoIncl.Dati[i].PITCH / 1000)
                Catena.Sensori[j].Dati[k].Roll  = Catena.Sensori[j].Dati[k].Roll  - (this.ObjDati.AllineamentoIncl.Dati[i].ROLL / 1000)
              }
            }
          }
        }
      }
    },

    OrdinamentoDatiPerData(Catena, IsCaricaGraficiGV)
    {
      if(!IsCaricaGraficiGV)
      {
        for(let i = 0; i < Catena.Sensori.length; i++)
        { 
          Catena.Sensori[i].Dati.sort(function(a,b)
          {
            if(a.Data < b.Data)
              return -1
            if(a.Data > b.Data)
              return 1
            return 0
          })
        }
      }
    },

    CalcoloBarraDiProgressione(LunghezzaArray, index)
    {
      if(LunghezzaArray != 0)
      {
        let PercentualePerIndex = 100 / LunghezzaArray
        this.OggettoModalCaricamentoDati.Width       = PercentualePerIndex * index
        this.OggettoModalCaricamentoDati.DatoPassato = true
      }
      else 
      {
        this.OggettoModalCaricamentoDati.Width       = 0.01
        this.OggettoModalCaricamentoDati.DatoPassato = true
      }
    },

    CalcoloMassimoNumeroAsseY(Catena)
    {
      switch (this.TipoGrafico)
      {
        case (this.TipiStorici.EV_ACCELEROMETRICI_SINTETICI_A) :
        {
          this.MaxYAmpAccelerometri(Catena)
          break
        }
        case (this.TipiStorici.EV_ACCELEROMETRICI_SINTETICI_F) :
        {
          this.MaxYFreqAccelerometri(Catena)
          break
        }
        case (this.TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE) :
        {
          this.MaxYAmpAccelerometri(Catena)
          break
        }
        case (this.TipiStorici.CAMPIONI_RILEVATI) :
        {
          this.MaxYCampioniRilevati(Catena)
          break
        }
        case (this.TipiStorici.GRAFICI_GV) :
        {
          this.MaxYSpostamenti(Catena, true)
          this.MaxYTensioneAssorbimento(Catena)
          this.MaxYCampioniRilevati(Catena)
          this.MaxYFreqAccelerometri(Catena, true)
          this.MaxYAmpAccelerometri(Catena, true)
          break
        }
        case (this.TipiStorici.SPOSTAMENTI_GRAFICI_SEPARATI) :
        case (this.TipiStorici.SPOSTAMENTI_GRAFICI_SOVR) :
        case (this.TipiStorici.VELOCITA_MEDIA_ORARIA) :
        case (this.TipiStorici.ACCELERAZIONE_MEDIA_ORARIA) :
        case (this.TipiStorici.VELOCITA_MEDIA_GIORNALIERA) :
        case (this.TipiStorici.ACCELERAZIONE_MEDIA_GIORNALIERA) :
        case (this.TipiStorici.STAZIONE_METEO) :
        {
          this.MaxYSpostamenti(Catena)
          break
        }
        case (this.TipiStorici.ASSORBIMENTO) :
        case (this.TipiStorici.TENSIONE_ALIMENTAZIONE) :
        {
          this.MaxYTensioneAssorbimento(Catena)
          break
        }
      }
    },

    MaxYTensioneAssorbimento(Catena)
    {
      if(Catena != null)
        for(let i = 0; i < Catena.Sensori.length; i++)
        {
          Catena.Sensori[i].MaxAdattamentoAsseYTen = 15
          Catena.Sensori[i].MinAdattamentoAsseYTen = 0
          Catena.Sensori[i].UdmYTen                = 1

          Catena.Sensori[i].MaxAdattamentoAsseYAss = 30
          Catena.Sensori[i].MinAdattamentoAsseYAss = 0
          Catena.Sensori[i].UdmYAss                = 2
        }
    },

    MaxYSpostamenti(Catena, IsGraficoGV = false)
    {
      if(Catena != null)
      {
        let MaxSpostamento     = 0
        let MaxVelocita        = 0
        let MaxAccelerazione   = 0

        let ScalaVelocità      = 1
        let ScalaAccelerazione = 1
        let ScalaSpostamento   = 1

        for(let i = 0; i < Catena.Sensori.length; i++)
        {
          for(let j = 0; j < Catena.Sensori[i].Dati.length; j++)
          {
            if(Catena.Sensori[i].Dati[j].Spostamento != null)
              if(MaxSpostamento < Math.abs(Catena.Sensori[i].Dati[j].Spostamento))
                MaxSpostamento = Math.abs(Catena.Sensori[i].Dati[j].Spostamento)

            if(Catena.Sensori[i].Dati[j].Velocita != null)
              if(MaxVelocita < Math.abs(Catena.Sensori[i].Dati[j].Velocita))
                MaxVelocita = Math.abs(Catena.Sensori[i].Dati[j].Velocita)
            
            if(Catena.Sensori[i].Dati[j].Accelerazione != null)
              if(MaxAccelerazione < Math.abs(Catena.Sensori[i].Dati[j].Accelerazione))
                MaxAccelerazione = Math.abs(Catena.Sensori[i].Dati[j].Accelerazione)
          }
        }

        for(let i = 0; i < Catena.Sensori.length; i++)
        {
          // SPOSTAMENTO
          ScalaSpostamento = TInfoGraphic.ChooseScale(MaxSpostamento * 1.02)
          
          Catena.Sensori[i].MaxAdattamentoAsseYSpost = ScalaSpostamento
          Catena.Sensori[i].MinAdattamentoAsseYSpost = (-1) * Catena.Sensori[i].MaxAdattamentoAsseYSpost

          if(Catena.Sensori[i].MaxAdattamentoAsseYSpost == 12)
            Catena.Sensori[i].UdmYSpost = 2
          else Catena.Sensori[i].UdmYSpost = TZMathFunct.GetMultiplo(Math.abs(Catena.Sensori[i].MaxAdattamentoAsseYSpost - Catena.Sensori[i].MinAdattamentoAsseYSpost) / 10, 0.1, 'eccesso');


          // VELOCITA
          ScalaVelocità = TInfoGraphic.ChooseScale(MaxVelocita * 1.02)
          
          Catena.Sensori[i].MaxAdattamentoAsseYVel = ScalaVelocità
          Catena.Sensori[i].MinAdattamentoAsseYVel = (-1) * ScalaVelocità

          if(Catena.Sensori[i].MaxAdattamentoAsseYVel == 12)
            Catena.Sensori[i].UdmYVel = 2
          else Catena.Sensori[i].UdmYVel = TZMathFunct.GetMultiplo(Math.abs(Catena.Sensori[i].MaxAdattamentoAsseYVel - Catena.Sensori[i].MinAdattamentoAsseYVel) / 10, 0.1, 'eccesso');


          // ACCELERAZIONE
          ScalaAccelerazione = TInfoGraphic.ChooseScale(MaxAccelerazione * 1.02)

          Catena.Sensori[i].MaxAdattamentoAsseYAccel = ScalaAccelerazione
          Catena.Sensori[i].MinAdattamentoAsseYAccel = (-1) * Catena.Sensori[i].MaxAdattamentoAsseYAccel

          if(Catena.Sensori[i].MaxAdattamentoAsseYAccel == 12)
            Catena.Sensori[i].UdmYAccel = 2
          else Catena.Sensori[i].UdmYAccel = TZMathFunct.GetMultiplo(Math.abs(Catena.Sensori[i].MaxAdattamentoAsseYAccel - Catena.Sensori[i].MinAdattamentoAsseYAccel) / 10, 0.1, 'eccesso');

          // MaxVelocita = MaxVelocita * 10
          //   MaxVelocita = Math.ceil(MaxVelocita)
          //   if(MaxVelocita < 2)
          //     MaxVelocita = 2
          //   MaxVelocita = MaxVelocita / 10
          //   Catena.Sensori[i].MaxAdattamentoAsseYVel = MaxVelocita * 1.02
          //   Catena.Sensori[i].MinAdattamentoAsseYVel = -Catena.Sensori[i].MaxAdattamentoAsseYVel

        }

        if(IsGraficoGV)
        {
          if (this.ObjTotaleSpostamento != null && this.ObjTotaleSpostamento.ListaTotaliSpostamento != null)
            this.MaxYSpostTotale(Catena, this.ObjTotaleSpostamento)

          if (this.ObjTotaleVelocitaGG != null && this.ObjTotaleVelocitaGG.ListaTotaliSpostamento != null)
            this.MaxYSpostTotale(Catena, this.ObjTotaleVelocitaGG)

          if (this.ObjTotaleVelocitaH != null && this.ObjTotaleVelocitaH.ListaTotaliSpostamento != null)
            this.MaxYSpostTotale(Catena, this.ObjTotaleVelocitaH)

          if (this.ObjTotaleAccelerazioneGG != null && this.ObjTotaleAccelerazioneGG.ListaTotaliSpostamento != null)
            this.MaxYSpostTotale(Catena, this.ObjTotaleAccelerazioneGG)

          if (this.ObjTotaleAccelerazioneH != null && this.ObjTotaleAccelerazioneH.ListaTotaliSpostamento != null)
            this.MaxYSpostTotale(Catena, this.ObjTotaleAccelerazioneH)
        }
        else
        {
          if (Catena.OggettoTotaleSpostamento != null && Catena.OggettoTotaleSpostamento.ListaTotaliSpostamento != null)
          {
            this.MaxYSpostTotale(Catena, Catena.OggettoTotaleSpostamento)
          }
        }
      }
    },

    MaxYSpostTotale(Catena, ObjTotale)
    {
      let MaxSpostamentoTotale = 0

      for(let i = 0; i < ObjTotale.ListaTotaliSpostamento.length; i++)
      {
        if(ObjTotale.ListaTotaliSpostamento[i].SpostamentoTotale != null)
          if(MaxSpostamentoTotale < Math.abs(ObjTotale.ListaTotaliSpostamento[i].SpostamentoTotale))
            MaxSpostamentoTotale = Math.abs(ObjTotale.ListaTotaliSpostamento[i].SpostamentoTotale)
      }

      let ScalaSpostamento = TInfoGraphic.ChooseScale(MaxSpostamentoTotale * 1.02)
      
      ObjTotale.MaxAdattamentoAsseYSpost = ScalaSpostamento
      ObjTotale.MinAdattamentoAsseYSpost = (-1) * ObjTotale.MaxAdattamentoAsseYSpost

      if(ObjTotale.MaxAdattamentoAsseYSpost == 12)
        ObjTotale.UdmYSpost = 2
      else ObjTotale.UdmYSpost = TZMathFunct.GetMultiplo(Math.abs(ObjTotale.MaxAdattamentoAsseYSpost - ObjTotale.MinAdattamentoAsseYSpost) / 10, 0.1, 'eccesso');

      if(Catena.Sensori[0] != undefined)
      {
        ObjTotale.MaxProfondita = Catena.Sensori[0].Profondita + Catena.Sensori[0].Lunghezza
        ObjTotale.Lunghezza     = Catena.Sensori[0].Lunghezza
        ObjTotale.MinProfondita = Catena.Sensori[Catena.Sensori.length - 1].Profondita
      }
      else
      {
        ObjTotale.MaxProfondita = 10
        ObjTotale.Lunghezza     = 1
        ObjTotale.MinProfondita = 0
      }
    },

    MaxYCampioniRilevati(Catena)
    {
      if(Catena != null)
      {
        let MaxPitch = 0
        let MaxRoll  = 0
        
        let MaxTemp  = 0
        let MinTemp  = 0

        let MaxDef   = 0.5

        for(let i = 0; i < Catena.Sensori.length; i++)
        {
          for(let j = 0; j < Catena.Sensori[i].Dati.length; j++)
          {
            if(Catena.Sensori[i].Dati[j].Pitch != null)
              if(MaxPitch < Math.abs(Catena.Sensori[i].Dati[j].Pitch))
                MaxPitch = Math.abs(Catena.Sensori[i].Dati[j].Pitch)

            if(Catena.Sensori[i].Dati[j].Roll != null)
              if(MaxRoll < Math.abs(Catena.Sensori[i].Dati[j].Roll))
                MaxRoll = Math.abs(Catena.Sensori[i].Dati[j].Roll)
            
            if(Catena.Sensori[i].Dati[j].Temperatura != null)
              if(MaxTemp < Math.abs(Catena.Sensori[i].Dati[j].Temperatura))
                MaxTemp = Math.abs(Catena.Sensori[i].Dati[j].Temperatura)
            if(Catena.Sensori[i].Dati[j].Temperatura != null)
              if(MinTemp > Catena.Sensori[i].Dati[j].Temperatura)
                MinTemp = Catena.Sensori[i].Dati[j].Temperatura

            if(Catena.Sensori[i].Dati[j].Deformazione != null)
              if(MaxDef < Math.abs(Catena.Sensori[i].Dati[j].Deformazione))
                MaxDef = Math.abs(Catena.Sensori[i].Dati[j].Deformazione)
          }
        }

        let MaxAdattamentoAsseY      = MaxPitch < MaxRoll? MaxRoll : MaxPitch

        if(MaxAdattamentoAsseY < 0.2)
          MaxAdattamentoAsseY = MaxAdattamentoAsseY + 0.2

        MaxAdattamentoAsseY     = TZMathFunct.GetMultiplo(MaxAdattamentoAsseY, 0.2, 'Eccesso')

        var OggettoAdattamentoTemp = this.GestioneAdattamentoTemperatura(MaxTemp, MinTemp)

        // DA FARE
        // CALCOLARE LE FALDE PER IL TOTALE (MIN, MAX, ECC...)
        
        for(let i = 0; i < Catena.Sensori.length; i++)
        {
          Catena.Sensori[i].MaxAdattamentoAsseY = MaxAdattamentoAsseY
          Catena.Sensori[i].MinAdattamentoAsseY = -MaxAdattamentoAsseY
          
          Catena.Sensori[i].UdmY = MaxAdattamentoAsseY / 5

          Catena.Sensori[i].MaxAdattamentoAsseYDef = MaxDef
          Catena.Sensori[i].MinAdattamentoAsseYDef = -MaxDef
          Catena.Sensori[i].UdmYDef                = 0.2 * MaxDef

          this.GetEstremiPressionePerSensore(Catena.Sensori[i])

          if(OggettoAdattamentoTemp != null)
          {
            Catena.Sensori[i].MaxAdattamentoAsseTemp = OggettoAdattamentoTemp.Max
            Catena.Sensori[i].MinAdattamentoAsseTemp = OggettoAdattamentoTemp.Min
            Catena.Sensori[i].UdmTemp                = OggettoAdattamentoTemp.UdmT
          }
        }
      }
    },

    MaxYCampioniRilevatiFiltrati(CurrentModulo)
    {
      let MaxPitch = 0
      let MaxRoll  = 0
      
      let MaxTemp  = 0
      let MinTemp  = 0

      let MaxDef   = 0.5

      for(let j = 0; j < CurrentModulo.Dati.length; j++)
      {
        if(CurrentModulo.Dati[j].Pitch != null)
          if(MaxPitch < Math.abs(CurrentModulo.Dati[j].Pitch))
            MaxPitch = Math.abs(CurrentModulo.Dati[j].Pitch)

        if(CurrentModulo.Dati[j].Roll != null)
          if(MaxRoll < Math.abs(CurrentModulo.Dati[j].Roll))
            MaxRoll = Math.abs(CurrentModulo.Dati[j].Roll)
        
        if(CurrentModulo.Dati[j].Temperatura != null)
          if(MaxTemp < Math.abs(CurrentModulo.Dati[j].Temperatura))
            MaxTemp = Math.abs(CurrentModulo.Dati[j].Temperatura)
        if(CurrentModulo.Dati[j].Temperatura != null)
          if(MinTemp > CurrentModulo.Dati[j].Temperatura)
            MinTemp = CurrentModulo.Dati[j].Temperatura

        if(CurrentModulo.Dati[j].Deformazione != null)
          if(MaxDef < Math.abs(CurrentModulo.Dati[j].Deformazione))
            MaxDef = Math.abs(CurrentModulo.Dati[j].Deformazione)
      }

      let MaxAdattamentoAsseY      = MaxPitch < MaxRoll? MaxRoll : MaxPitch

      if(MaxAdattamentoAsseY < 0.2)
        MaxAdattamentoAsseY = MaxAdattamentoAsseY + 0.2

      MaxAdattamentoAsseY     = TZMathFunct.GetMultiplo(MaxAdattamentoAsseY, 0.2, 'Eccesso')

      var OggettoAdattamentoTemp = this.GestioneAdattamentoTemperatura(MaxTemp, MinTemp)

      CurrentModulo.MaxAdattamentoAsseY = MaxAdattamentoAsseY
      CurrentModulo.MinAdattamentoAsseY = -MaxAdattamentoAsseY
      
      CurrentModulo.UdmY = MaxAdattamentoAsseY / 5

      CurrentModulo.MaxAdattamentoAsseYDef = MaxDef
      CurrentModulo.MinAdattamentoAsseYDef = -MaxDef
      CurrentModulo.UdmYDef                = 0.2 * MaxDef

      this.GetEstremiPressionePerSensoreFiltrati(CurrentModulo)

      if(OggettoAdattamentoTemp != null)
      {
        CurrentModulo.MaxAdattamentoAsseTemp = OggettoAdattamentoTemp.Max
        CurrentModulo.MinAdattamentoAsseTemp = OggettoAdattamentoTemp.Min
        CurrentModulo.UdmTemp                = OggettoAdattamentoTemp.UdmT
      }
    },
    
    GetEstremiPressionePerSensoreFiltrati(Sensore)
    {
      let MaxPress = 0
      let MinPress = 0

      if (Sensore.Dati.length > 0)
      {
        MaxPress = Sensore.Dati[0].Pressione
        MinPress = Sensore.Dati[0].Pressione
      }

      for(let j = 0; j < Sensore.Dati.length; j++)
      {
        if(Sensore.Dati[j].Pressione != null)
          if(MaxPress < Sensore.Dati[j].Pressione)
            MaxPress = Sensore.Dati[j].Pressione

        if(Sensore.Dati[j].Pressione != null)
          if(MinPress > Sensore.Dati[j].Pressione)
            MinPress = Sensore.Dati[j].Pressione
      }

      if(MaxPress != 0 || MinPress != 0)
      {
        let SemiWidth = (Math.abs(MaxPress - MinPress) * 0.08) / 2;
        Sensore.MinAdattamentoAsseYPress = MinPress - Sensore.ProfonditaCoda - SemiWidth;
        Sensore.MaxAdattamentoAsseYPress = MaxPress - Sensore.ProfonditaCoda + SemiWidth;

        let UdmYPress = Math.abs(Sensore.MaxAdattamentoAsseYPress - Sensore.MinAdattamentoAsseYPress) / 10

        if(UdmYPress < 0.1)
          UdmYPress = TZMathFunct.GetMultiplo(UdmYPress, 0.01, 'Eccesso')
        else UdmYPress = TZMathFunct.GetMultiplo(UdmYPress, 0.1, 'Eccesso')

        if(UdmYPress < 0.01)
          UdmYPress = 0.01;

        Sensore.UdmYPress = UdmYPress
      }
      else
      {
        Sensore.MinAdattamentoAsseYPress =  0.2 
        Sensore.MaxAdattamentoAsseYPress = -0.2
        Sensore.UdmYPress                =  0.1 
      }      
    },
    
    GetEstremiPressionePerSensore(Sensore)
    {
      let MaxPress = 0
      let MinPress = 0

      if (Sensore.Dati.length > 0)
      {
        MaxPress = Sensore.Dati[0].Pressione
        MinPress = Sensore.Dati[0].Pressione
      }

      for(let j = 0; j < Sensore.Dati.length; j++)
      {
        if(Sensore.Dati[j].Pressione != null)
          if(MaxPress < Sensore.Dati[j].Pressione)
            MaxPress = Sensore.Dati[j].Pressione

        if(Sensore.Dati[j].Pressione != null)
          if(MinPress > Sensore.Dati[j].Pressione)
            MinPress = Sensore.Dati[j].Pressione
      }

      if(MaxPress != 0 || MinPress != 0)
      {
        let SemiWidth = (Math.abs(MaxPress - MinPress) * 0.08) / 2;
        Sensore.MinAdattamentoAsseYPress = MinPress - Sensore.ProfonditaCoda - SemiWidth;
        Sensore.MaxAdattamentoAsseYPress = MaxPress - Sensore.ProfonditaCoda + SemiWidth;

        let UdmYPress = Math.abs(Sensore.MaxAdattamentoAsseYPress - Sensore.MinAdattamentoAsseYPress) / 10

        if(UdmYPress < 0.1)
          UdmYPress = TZMathFunct.GetMultiplo(UdmYPress, 0.01, 'Eccesso')
        else UdmYPress = TZMathFunct.GetMultiplo(UdmYPress, 0.1, 'Eccesso')

        if(UdmYPress < 0.01)
          UdmYPress = 0.01;

        Sensore.UdmYPress = UdmYPress
      }
      else
      {
        Sensore.MinAdattamentoAsseYPress =  0.2 
        Sensore.MaxAdattamentoAsseYPress = -0.2
        Sensore.UdmYPress                =  0.1 
      }
    },

    GestioneAdattamentoTemperatura(Max, Min)
    {
      let OggettoAdattamentoTemp = {}
      if(Max < 30)
        Max = 30
      if(Min > 0)
        Min = 0
      
      OggettoAdattamentoTemp.Max = TZMathFunct.GetMultiplo(Max, 5, 'Eccesso')
      OggettoAdattamentoTemp.Min = TZMathFunct.GetMultiplo(Min, 5, 'Difetto')

      let UdmT = Math.abs(OggettoAdattamentoTemp.Min - OggettoAdattamentoTemp.Max) / 6;
      OggettoAdattamentoTemp.UdmT = TZMathFunct.GetMultiplo(UdmT, 5, 'Difetto')

      if(OggettoAdattamentoTemp.UdmT == 0)
        OggettoAdattamentoTemp.UdmT = 5

      return OggettoAdattamentoTemp
    },
    
    MaxYFreqAccelerometri(Catena, IsGraficoGV = false)
    {
      if(Catena != null)
      {
        let MaxAdattamentoAsseY = 10
        let UdmY                = 0
        for(let i = 0; i < Catena.Sensori.length; i++)
        {
          if(IsGraficoGV)
          {
            if(Catena.Sensori[i].DatiEvAccF != undefined)
              for(let j = 0; j < Catena.Sensori[i].DatiEvAccF.length; j++)
              {
                let SingleDato = Catena.Sensori[i].DatiEvAccF[j]
                MaxAdattamentoAsseY = Math.max(SingleDato.Conteggio, MaxAdattamentoAsseY)
              }
          }
          else
          {
            for(let j = 0; j < Catena.Sensori[i].Dati.length; j++)
            {
              let SingleDato = Catena.Sensori[i].Dati[j]
              MaxAdattamentoAsseY = Math.max(SingleDato.Conteggio, MaxAdattamentoAsseY)
            }
          }
        }
        
        MaxAdattamentoAsseY = TZMathFunct.GetMultiplo(MaxAdattamentoAsseY, 10, 'Eccesso')
        if (MaxAdattamentoAsseY == 0)
          MaxAdattamentoAsseY = 100
        if (MaxAdattamentoAsseY > 500)
          UdmY = TZMathFunct.GetMultiplo((MaxAdattamentoAsseY / 10), 10, 'Difetto')
        else
        {
          if (MaxAdattamentoAsseY > 100)
          {
            UdmY = 50
          }
          else
          {
            if (MaxAdattamentoAsseY > 50)
            {
              UdmY = 10
            }
            else
            {
              if (MaxAdattamentoAsseY > 10)
              {
                UdmY = 5
              }
              else
              {
                UdmY = 1
              }
            }
          }
        }

        for(let i = 0; i < Catena.Sensori.length; i++)
        {
          if(!IsGraficoGV)
          {
            Catena.Sensori[i].MaxAdattamentoAsseY = MaxAdattamentoAsseY
            Catena.Sensori[i].MinAdattamentoAsseY = 0
            Catena.Sensori[i].UdmY = UdmY
          }
          else
          {
            Catena.Sensori[i].MaxAdattamentoAsseYFreqAcc = MaxAdattamentoAsseY
            Catena.Sensori[i].MinAdattamentoAsseYFreqAcc = 0
            Catena.Sensori[i].UdmYFreqAcc = UdmY
          }
        }
      }
    },

    MaxYAmpAccelerometri(Catena, IsGraficoGV = false)
    {
      if(Catena != null)
      {
        let MaxAdattamentoAsseY = 10
        let UdmY                = 0
        for(let i = 0; i < Catena.Sensori.length; i++)
        {
          if(IsGraficoGV)
          {
            if(Catena.Sensori[i].DatiEvAccF != undefined)
              for(let j = 0; j < Catena.Sensori[i].DatiEvAccA.length; j++)
              {
                let SingleDato = Catena.Sensori[i].DatiEvAccA[j]
                MaxAdattamentoAsseY = Math.max(Math.abs(SingleDato.MaxAccX - SingleDato.MinAccX), Math.abs(SingleDato.MaxAccY - SingleDato.MinAccY), Math.abs(SingleDato.MaxAccZ - SingleDato.MinAccZ), MaxAdattamentoAsseY)
              }
          }
          else
          {
            for(let j = 0; j < Catena.Sensori[i].Dati.length; j++)
            {
              let SingleDato = Catena.Sensori[i].Dati[j]
              MaxAdattamentoAsseY = Math.max(Math.abs(SingleDato.MaxAccX - SingleDato.MinAccX), Math.abs(SingleDato.MaxAccY - SingleDato.MinAccY), Math.abs(SingleDato.MaxAccZ - SingleDato.MinAccZ), MaxAdattamentoAsseY)
            }
          }

        }
        
        MaxAdattamentoAsseY = TZMathFunct.GetMultiplo(MaxAdattamentoAsseY, 10, 'Eccesso')
        if (MaxAdattamentoAsseY == 0)
          MaxAdattamentoAsseY = 100
        if (MaxAdattamentoAsseY > 500)
        {
          UdmY = TZMathFunct.GetMultiplo((MaxAdattamentoAsseY / 10), 10, 'Difetto')
        }
        else
        {
          if (MaxAdattamentoAsseY > 100)
          {
            UdmY = 50
          }
          else
          {
            if (MaxAdattamentoAsseY > 50)
            {
              UdmY = 10
            }
            else
            {
              if (MaxAdattamentoAsseY > 10)
              {
                UdmY = 5
              }
              else
              {
                UdmY = 1
              }
            }
          }
        }

        for(let i = 0; i < Catena.Sensori.length; i++)
        {
          if(!IsGraficoGV)
          {
            Catena.Sensori[i].MaxAdattamentoAsseY = MaxAdattamentoAsseY
            Catena.Sensori[i].MinAdattamentoAsseY = 0
            Catena.Sensori[i].UdmY = UdmY
          }
          else
          {
            Catena.Sensori[i].MaxAdattamentoAsseYAmpAcc = MaxAdattamentoAsseY
            Catena.Sensori[i].MinAdattamentoAsseYAmpAcc = 0
            Catena.Sensori[i].UdmYAmpAcc = UdmY
          }
        }
      }
    },

    GestioneDeiDatiAcquisitiDaDatabase(Catena)
    {
      if (this.ArrayGrafica1.includes(this.TipoGrafico))
      {
        this.VettoreBottoni       = []
        
        let NumeroBottoni         = 0
        let ElementiUltimoBottone = 0
        var OggettoBottone        = {}

        NumeroBottoni         = parseInt(Catena.Sensori.length / NR_OGGETTI_BOTTONI)
        ElementiUltimoBottone = Catena.Sensori.length % NR_OGGETTI_BOTTONI

        for(let i = 0; i < NumeroBottoni; i++)
        {
          OggettoBottone     = {}
          OggettoBottone.Id  = i
          OggettoBottone.Dal = i * NR_OGGETTI_BOTTONI
          OggettoBottone.Al  = ((i + 1) * NR_OGGETTI_BOTTONI) - 1 
          OggettoBottone.Selezionato = false
          this.VettoreBottoni.push(OggettoBottone)
        }
        if (NumeroBottoni > 0)
        {
          if (ElementiUltimoBottone != 0)
          {
            OggettoBottone     = {}
            OggettoBottone.Id  = NumeroBottoni + 1
            OggettoBottone.Dal = NumeroBottoni * NR_OGGETTI_BOTTONI
            OggettoBottone.Al  = (NumeroBottoni * NR_OGGETTI_BOTTONI) + ElementiUltimoBottone - 1 
            OggettoBottone.Selezionato = false
            this.VettoreBottoni.push(OggettoBottone)
          }
          this.CurrentBottone = this.VettoreBottoni[0]
          this.SceltaRangeGrafici = true
          this.MixInsOnClickBottoniIndici(Catena, this.VettoreBottoni[0])
        }
        else
        {
          this.ModuliMostrati = []
          for (let i = 0; i < Catena.Sensori.length; i++)
          {
            Catena.Sensori[i]
            this.ModuliMostrati.push(Catena.Sensori[i])
          }
        }
      }
      else
      {
        if (this.TipoGrafico == this.TipiStorici.EV_ACCELEROMETRICI_SUP_SOGLIE)
        {
          let VettoreEventi = []
          for (let i = 0; i < this.ListaSuperamentiSoglia.length; i++)
          {
            let Evento = this.ListaSuperamentiSoglia[i]
            Evento.Mostra = true
            Evento.ModuliString = ''
            Evento.Letto = true
            let VettoreModuliDiversi = []
            for (let j = 0; j < Evento.Moduli.length; j++)
            {
              Evento.Moduli[j].Campioni = []
              if (!VettoreModuliDiversi.includes(Evento.Moduli[j].Modulo))
              {
                if (Evento.ModuliString != '')
                  Evento.ModuliString += ', '
                Evento.ModuliString += Evento.Moduli[j].Modulo
                VettoreModuliDiversi.push(Evento.Moduli[j].Modulo)
              }
              if (!Evento.Moduli[j].Letto)
                Evento.Letto = false
            }
            VettoreEventi.unshift(Evento)
          }
          this.ListaSuperamentiSoglia = VettoreEventi
          if (this.ListaSuperamentiSoglia.length > 0)
          {
            this.ListaSuperamentiSoglia[0].Evidenziato = true
            this.MixInsSegnaComeLetto(this.ListaSuperamentiSoglia[0])
            this.EventoSelezionato = this.ListaSuperamentiSoglia[0]
            this.MixInsGetUltimaData()
            this.MixInsCaricaCampioniSingleEvento(this.EventoSelezionato)
          }
          else
            this.EventoSelezionato = null
        }
        else
        {
          let MsStacking = this.Stacking * 60 * 60 * 1000
          this.ListaEventiAccorpati = []
          for (let i = 0; i < this.ListaSuperamentiSoglia.length; i++)
          {
            let Evento = this.ListaSuperamentiSoglia[i]
            Evento.Mostra = true
            let CampioneConsiderato = null
            for (let j = 0; j < Evento.Dati.length; j++)
            {
              let SingleCampione = Evento.Dati[j]
              let DataCampione = (new Date(SingleCampione.Data)).valueOf()
              if ((CampioneConsiderato == null) ||
                  (CampioneConsiderato.DataInt + MsStacking < DataCampione))
              {
                CampioneConsiderato = SingleCampione
                CampioneConsiderato.DataInt = DataCampione
                CampioneConsiderato.Modulo = Evento.Id
                CampioneConsiderato.Profondita = Evento.Profondita
                CampioneConsiderato.MaxAmpiezza = 0
                CampioneConsiderato.Frequenza = 0
                this.ListaEventiAccorpati.push(CampioneConsiderato)
              }
              CampioneConsiderato.Frequenza++   
              let Max = Math.max(Math.abs(SingleCampione.MaxAccX - SingleCampione.MinAccX),
                                 Math.abs(SingleCampione.MaxAccY - SingleCampione.MinAccY),
                                 Math.abs(SingleCampione.MaxAccZ - SingleCampione.MinAccZ))
              if (Max > CampioneConsiderato.MaxAmpiezza)
                CampioneConsiderato.MaxAmpiezza = Max
            }
          }
          this.GraficiChange++
        }
      }
    },

    MixInsCaricaCampioniSingleEvento(Evento)
    {
      let Self = this
      let ParametriQuery         = {}
      ParametriQuery.Data = Evento.Id
      ParametriQuery.Stacking = this.Stacking
      ParametriQuery.IdSito   = this.ObjDati.IdSito
      ParametriQuery.IdCatena   = this.ObjDati.IdCatena
      this.Mostra = false
      SystemInformation.AdvQuery.ExecuteExternalScript('ExtraCampioniSuperamentiSoglia', ParametriQuery, function(Answer) 
      {
        Evento.MsEnd = 0
        Evento.Moduli.forEach((element) =>
        {
          element.Campioni = []
          let ObjCampione = Answer.QueryData.find((Campione) =>
          {
            return Campione.Modulo == element.Modulo && Campione.DataEffettiva == element.DataEffettiva && Campione.Millisecondi == element.Millisecondi
          })
          if (ObjCampione == undefined)
            throw new Error(Self.GetTraduzioneLabel('VUEAppContentGraficiStorici','TKN_APP_CON_GRAF_STO_ERR_SCARICO_DATI',Self.LinguaUtente))
          element.Campioni = ObjCampione.Campioni
          Evento.MsEnd = Math.max(Evento.MsEnd, (new Date(ObjCampione.DataEffettiva).valueOf() + (ObjCampione.Campioni.length * element.PeriodoCampionamento)))
        })
        Self.Mostra = true
      },
      function(ErrorMessage,DescrErrore)
      {
        Self.CaricamentoDatiSiti = false
        alert(ErrorMessage + '[' + DescrErrore + ']')
      })   
    },

    MixInsGetUltimaData()
    {
      let UltimaData = ''
      this.EventoSelezionato.Moduli.forEach((element) =>
      {
        if (UltimaData == '')
          UltimaData == element.DataEffettiva
        if (element.DataEffettiva > UltimaData)
          UltimaData = element.DataEffettiva
      })
      this.EventoSelezionato.UltimaData = UltimaData
    },

    MixInsSegnaComeLetto(Evento = null)
    {
      let ObjQuery = {Operazioni : []}
      if (Evento != null)
      {
        if (!Evento.Letto)
        {
          Evento.Letto = true
          for (let  i = 0; i < Evento.Moduli.length; i++)
          {
            if (!Evento.Moduli[i].Letto)
            {
              let Modulo = Evento.Moduli[i]
              Modulo.Letto = true            
              let ObjCatena = {Query : 'SegnaComeLetto', Parametri: {}}
              ObjCatena.Parametri = {
                                      Data   : Modulo.DataEffettiva,
                                      Modulo : Modulo.Modulo,
                                      Catena : this.ObjDati.IdCatena
                                    }
              ObjQuery.Operazioni.push(ObjCatena)
            }
          }
        }
      }
      else
      {
        this.EventiMostrati.forEach((element) =>
        {
          if (!element.Letto)
          {
            element.Letto = true
            for (let  i = 0; i < element.Moduli.length; i++)
            {
              if (!element.Moduli[i].Letto)
              {
                let Modulo = element.Moduli[i]
                Modulo.Letto = true            
                let ObjCatena = {Query : 'SegnaComeLetto', Parametri: {}}
                ObjCatena.Parametri = {
                                        Data   : Modulo.DataEffettiva,
                                        Modulo : Modulo.Modulo,
                                        Catena : this.ObjDati.IdCatena
                                      }
                ObjQuery.Operazioni.push(ObjCatena)
              }
            }
          }
        })        
      }
      if (ObjQuery.Operazioni.length > 0)
      {
        SystemInformation.AdvQuerySiti.SessionId = SystemInformation.AdvQuery.SessionId          
        SystemInformation.AdvQuerySiti.PostSQL('EventiStoriciAcc', ObjQuery, 
                                                          function()
                                                          {
                                                          },
                                                          function(HTTPError,SubHTTPError,Response)
                                                          {
                                                            SystemInformation.HandleError(HTTPError,SubHTTPError,Response);
                                                          },
                                                          false, {DMSEWSito: this.ObjDati.IdSito})
      }
    },

    MixInsOnClickBottoniIndici(Catena, OggettoBottone)
    {
      if (!OggettoBottone.Selezionato)
      {
        this.ModuliMostrati = []
        for (let i = 0; i < this.VettoreBottoni.length; i++)
        {
          this.VettoreBottoni[i].Selezionato = false
        }
        let StartIndex = OggettoBottone.Dal
        let EndIndex = OggettoBottone.Al
        for (let i = StartIndex; i <= EndIndex; i++)
        {
          if (i == StartIndex || i == StartIndex + 1)
            Catena.Sensori[i].Disegna = true
          this.ModuliMostrati.push(Catena.Sensori[i])
        }
        OggettoBottone.Selezionato = !OggettoBottone.Selezionato
      }
    },
  }
}